// import React, { useEffect, useState, useRef } from "react";
// import { Link, NavLink, useNavigate } from "react-router-dom";
// import axios from "axios";
// import LiveSearch from "./LiveSearch/LiveSearch";

// const NOMINATIM_BASE = "https://nominatim.openstreetmap.org";

// /* ── Netflix-style Infinite Scrolling Strip ── */
// const InfiniteStripScroller = ({ categories }) => {
//   const trackRef = useRef(null);
//   const animFrameRef = useRef(null);
//   const posRef = useRef(0);
//   const pausedRef = useRef(true); // starts paused, begins after 1s delay
//   const halfWidthRef = useRef(0);
//   const startDelayRef = useRef(null);

//   // Build items: featured "Deals" + all categories + "Sell with us"
//   const items = [
//     {
//       id: "__deals__",
//       name: "Deals",
//       to: "/shop",
//       featured: true,
//       icon: "ph ph-fire",
//     },
//     ...categories.map((c) => ({
//       id: c._id,
//       name: c.name,
//       to: `/product-list-one?category=${c._id}`,
//     })),
//     {
//       id: "__seller__",
//       name: "Sell with us",
//       to: "/become-seller",
//       icon: "ph ph-storefront",
//     },
//   ];

//   // We render two copies side by side for seamless looping
//   const allItems = [...items, ...items];

//   useEffect(() => {
//     if (!trackRef.current || items.length === 0) return;

//     // Wait one tick for DOM to paint, measure half-width
//     const measure = () => {
//       const fullWidth = trackRef.current?.scrollWidth || 0;
//       halfWidthRef.current = fullWidth / 2;
//     };

//     const frame = requestAnimationFrame(measure);

//     // Start scrolling after 1 second delay
//     startDelayRef.current = setTimeout(() => {
//       pausedRef.current = false;
//     }, 1000);

//     const SPEED = 0.6; // px per frame (~36px/sec at 60fps)

//     const tick = () => {
//       if (!pausedRef.current && trackRef.current && halfWidthRef.current > 0) {
//         posRef.current += SPEED;
//         // Reset seamlessly when first copy fully scrolled past
//         if (posRef.current >= halfWidthRef.current) {
//           posRef.current = 0;
//         }
//         trackRef.current.style.transform = `translateX(-${posRef.current}px)`;
//       }
//       animFrameRef.current = requestAnimationFrame(tick);
//     };

//     animFrameRef.current = requestAnimationFrame(tick);

//     return () => {
//       cancelAnimationFrame(frame);
//       cancelAnimationFrame(animFrameRef.current);
//       clearTimeout(startDelayRef.current);
//     };
//   }, [categories]);

//   const handleMouseEnter = () => {
//     pausedRef.current = true;
//   };
//   const handleMouseLeave = () => {
//     pausedRef.current = false;
//   };

//   if (categories.length === 0) return null;

//   return (
//     <div
//       style={{ overflow: "hidden", width: "100%" }}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//     >
//       <div ref={trackRef} className="category-strip__track">
//         {allItems.map((item, idx) => (
//           <React.Fragment key={`${item.id}-${idx}`}>
//             <Link
//               to={item.to}
//               className={`category-strip__link${item.featured ? " strip-featured" : ""}`}
//             >
//               {item.icon && (
//                 <i className={item.icon} style={{ fontSize: "13px" }} />
//               )}
//               {item.name}
//             </Link>
//             <span className="category-strip__divider">·</span>
//           </React.Fragment>
//         ))}
//       </div>
//     </div>
//   );
// };
// /* ── END InfiniteStripScroller ── */

// const HeaderOne = () => {
//   const [scroll, setScroll] = useState(false);
//   const [location, setLocation] = useState({
//     display: "Detecting...",
//     city: "",
//     state: "",
//     country: "",
//   });
//   const [search, setSearch] = useState("");
//   const [suggestions, setSuggestions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const abortRef = useRef(null);
//   const debounceRef = useRef(null);

//   // handle scroll style
//   useEffect(() => {
//     const onScroll = () => setScroll(window.pageYOffset > 150);
//     window.addEventListener("scroll", onScroll);
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   // Fetch current location
//   const fetchCurrentLocation = () => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(
//         async (pos) => {
//           const { latitude, longitude } = pos.coords;
//           try {
//             const res = await fetch(
//               `${NOMINATIM_BASE}/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`,
//             );
//             const data = await res.json();
//             const addr = data.address || {};
//             const city =
//               addr.city || addr.town || addr.village || addr.county || "";
//             const state = addr.state || "";
//             const country = addr.country || "";
//             setLocation({
//               display: [city, state, country].filter(Boolean).join(", "),
//               city,
//               state,
//               country,
//             });
//           } catch {
//             setLocation({
//               display: "Unable to fetch location",
//               city: "",
//               state: "",
//               country: "",
//             });
//           }
//         },
//         () =>
//           setLocation({
//             display: "Location not available",
//             city: "",
//             state: "",
//             country: "",
//           }),
//       );
//     } else {
//       setLocation({
//         display: "Geolocation not supported",
//         city: "",
//         state: "",
//         country: "",
//       });
//     }
//   };

//   useEffect(() => {
//     fetchCurrentLocation();
//   }, []);

//   // handle search (debounced)
//   useEffect(() => {
//     if (!search || search.length < 2) {
//       setSuggestions([]);
//       return;
//     }

//     if (debounceRef.current) clearTimeout(debounceRef.current);
//     debounceRef.current = setTimeout(async () => {
//       setLoading(true);
//       if (abortRef.current) abortRef.current.abort();
//       abortRef.current = new AbortController();

//       try {
//         const res = await fetch(
//           `${NOMINATIM_BASE}/search?q=${encodeURIComponent(
//             search,
//           )}&format=json&addressdetails=1&limit=5`,
//           { signal: abortRef.current.signal },
//         );
//         const results = await res.json();
//         const sug = results.map((r) => {
//           const addr = r.address || {};
//           const city =
//             addr.city || addr.town || addr.village || addr.county || "";
//           const state = addr.state || "";
//           const country = addr.country || "";
//           return {
//             id: r.place_id,
//             display: r.display_name,
//             city,
//             state,
//             country,
//           };
//         });
//         setSuggestions(sug);
//       } catch {
//         setSuggestions([]);
//       } finally {
//         setLoading(false);
//       }
//     }, 400);

//     return () => clearTimeout(debounceRef.current);
//   }, [search]);

//   const handleSelectSuggestion = (s) => {
//     setLocation({
//       display: [s.city, s.state, s.country].filter(Boolean).join(", "),
//       city: s.city,
//       state: s.state,
//       country: s.country,
//     });
//     setSearch("");
//     setSuggestions([]);
//   };

//   // Set the default currency
//   const [selectedCurrency, setSelectedCurrency] = useState(
//     localStorage.getItem("selectedCurrency") || "INR",
//   );

//   useEffect(() => {
//     const saved = localStorage.getItem("selectedCurrency");
//     if (!saved) {
//       localStorage.setItem("selectedCurrency", "INR");
//       setSelectedCurrency("INR");
//       window.location.reload();
//     }
//   }, []);

//   const handleCurrencyChange = (currency) => {
//     setSelectedCurrency(currency);
//     localStorage.setItem("selectedCurrency", currency);
//     window.location.reload();
//   };

//   // Mobile menu support
//   const [menuActive, setMenuActive] = useState(false);
//   const [activeIndex, setActiveIndex] = useState(null);
//   const handleMenuClick = (index) => {
//     setActiveIndex(activeIndex === index ? null : index);
//   };
//   const handleMenuToggle = () => {
//     setMenuActive(!menuActive);
//   };

//   // Search control support
//   const [activeSearch, setActiveSearch] = useState(false);
//   const handleSearchToggle = () => {
//     setActiveSearch(!activeSearch);
//   };

//   // category control support
//   const navigate = useNavigate();
//   const [categories, setCategories] = useState([]);
//   const [activeIndexCat, setActiveIndexCat] = useState(null);
//   const [subcategories, setSubcategories] = useState({});
//   const [activeCategory, setActiveCategory] = useState(false);
//   const [cartCount, setCartCount] = useState(0);

//   // ── NEW: Amazon-style mega menu state ──
//   const [megaMenuOpen, setMegaMenuOpen] = useState(false);
//   const [megaHoveredCat, setMegaHoveredCat] = useState(null);
//   const megaMenuRef = useRef(null);
//   const megaLeaveTimer = useRef(null);

//   const handleMegaMouseEnter = () => {
//     if (megaLeaveTimer.current) clearTimeout(megaLeaveTimer.current);
//     setMegaMenuOpen(true);
//     if (categories.length > 0 && !megaHoveredCat) {
//       setMegaHoveredCat(categories[0]);
//     }
//   };

//   const handleMegaMouseLeave = () => {
//     megaLeaveTimer.current = setTimeout(() => {
//       setMegaMenuOpen(false);
//       setMegaHoveredCat(null);
//     }, 150);
//   };

//   const handleMegaCatHover = async (cat) => {
//     setMegaHoveredCat(cat);
//     if (subcategories[cat._id]) return;
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/subcategory/category/${cat._id}`,
//       );
//       if (response.data.success) {
//         setSubcategories((prev) => ({
//           ...prev,
//           [cat._id]: response.data.data,
//         }));
//       }
//     } catch (error) {
//       console.error("Error fetching subcategories:", error);
//     }
//   };
//   // ── END NEW ──

//   const handleCategoryToggle = () => {
//     setActiveCategory(!activeCategory);
//   };
//   const handleCatClick = (index) => {
//     setActiveIndexCat(activeIndexCat === index ? null : index);
//   };

//   const handleCatHover = async (index) => {
//     const categoryId = categories[index]._id;
//     setActiveIndexCat(index);

//     if (subcategories[categoryId]) return;

//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/subcategory/category/${categoryId}`,
//       );

//       if (response.data.success) {
//         setSubcategories((prev) => ({
//           ...prev,
//           [categoryId]: response.data.data,
//         }));
//       } else {
//         console.error("Failed to fetch subcategories:", response.data.message);
//       }
//     } catch (error) {
//       console.error("Error fetching subcategories:", error);
//     }
//   };

//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_URL}/category/all`,
//         );
//         setCategories(res.data.data);
//         if (res.data.data.length > 0) {
//           setMegaHoveredCat(res.data.data[0]);
//         }
//       } catch (err) {
//         console.error("Error fetching categories:", err);
//       }
//     };
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     const cartRaw = localStorage.getItem("cart");
//     const cart = cartRaw ? JSON.parse(cartRaw) : [];
//     setCartCount(cart.length);
//   }, []);

//   //   useEffect(() => {
//   //   const addScript = document.createElement("script");
//   //   addScript.src =
//   //     "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
//   //   addScript.async = true;

//   //   // window.googleTranslateElementInit = () => {
//   //   //   new window.google.translate.TranslateElement(
//   //   //     {
//   //   //       pageLanguage: "en",
//   //   //       // includedLanguages: "en,hi,fr,de,es",
//   //   //       includedLanguages: "en,hi,mr,ur,ar,bn,ta,te,kn,ml,gu,pa,or,as,fr,de,es,it,pt,ru,zh-CN,ja,ko,tr,nl,pl,sv,th,vi,id"
//   //   //     },
//   //   //     "google_translate_element"
//   //   //   );
//   //   // };

//   //   window.googleTranslateElementInit = () => {
//   //   new window.google.translate.TranslateElement(
//   //     {
//   //       pageLanguage: "en",
//   //       includedLanguages: "en,hi,mr,ur,ar,bn,ta,te,kn,ml,gu,pa,or,as,fr,de,es,it,pt,ru,zh-CN,ja,ko,tr,nl,pl,sv,th,vi,id",
//   //       layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
//   //       autoDisplay: false,
//   //     },
//   //     "google_translate_element"
//   //   );
//   // };

//   //   document.body.appendChild(addScript);
//   // }, []);

//   //   useEffect(() => {
//   //   // If already initialized, skip entirely
//   //   if (window.__gtInitialized) return;
//   //   window.__gtInitialized = true;

//   //   window.googleTranslateElementInit = () => {
//   //     try {
//   //       new window.google.translate.TranslateElement(
//   //         {
//   //           pageLanguage: "en",
//   //           includedLanguages: "en,hi,mr,ur,ar,bn,ta,te,kn,ml,gu,pa,or,as,fr,de,es,it,pt,ru,zh-CN,ja,ko,tr,nl,pl,sv,th,vi,id",
//   //           layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
//   //           autoDisplay: false,
//   //         },
//   //         "gt-container"
//   //       );
//   //       setTimeout(() => {
//   //         document.querySelectorAll(".goog-logo-link").forEach(el => el.remove());
//   //         const gadget = document.querySelector(".goog-te-gadget");
//   //         if (gadget) {
//   //           gadget.childNodes.forEach(node => {
//   //             if (node.nodeType === Node.TEXT_NODE) node.remove();
//   //             if (node.nodeName === "SPAN" && node.querySelector?.("a")) node.remove();
//   //           });
//   //         }
//   //       }, 800);
//   //     } catch (e) {
//   //       console.warn("GT init failed", e);
//   //     }
//   //   };

//   //   // Create container on body, outside React tree
//   //   if (!document.getElementById("gt-container")) {
//   //     const div = document.createElement("div");
//   //     div.id = "gt-container";
//   //     div.style.cssText = "position:fixed;top:10px;right:10px;z-index:99999;";
//   //     document.body.appendChild(div);
//   //   }

//   //   // Inject script only once
//   //   if (!document.getElementById("gt-script")) {
//   //     const s = document.createElement("script");
//   //     s.id = "gt-script";
//   //     s.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
//   //     s.async = true;
//   //     document.body.appendChild(s);
//   //   }
//   // }, []);

//   useEffect(() => {
//     if (window.__gtInitialized) return;
//     window.__gtInitialized = true;

//     window.googleTranslateElementInit = () => {
//       try {
//         new window.google.translate.TranslateElement(
//           {
//             pageLanguage: "en",
//             includedLanguages:
//               "en,hi,mr,ur,ar,bn,ta,te,kn,ml,gu,pa,or,as,fr,de,es,it,pt,ru,zh-CN,ja,ko,tr,nl,pl,sv,th,vi,id",
//             layout:
//               window.google.translate.TranslateElement.InlineLayout.SIMPLE,
//             autoDisplay: false,
//           },
//           "gt-container",
//         );
//         setTimeout(() => {
//           document
//             .querySelectorAll(".goog-logo-link")
//             .forEach((el) => el.remove());
//           const gadget = document.querySelector(".goog-te-gadget");
//           if (gadget) {
//             gadget.childNodes.forEach((node) => {
//               if (node.nodeType === Node.TEXT_NODE) node.remove();
//               if (node.nodeName === "SPAN" && node.querySelector?.("a"))
//                 node.remove();
//             });
//           }
//         }, 800);
//       } catch (e) {
//         console.warn("GT init failed", e);
//       }
//     };

//     if (!document.getElementById("gt-script")) {
//       const s = document.createElement("script");
//       s.id = "gt-script";
//       s.src =
//         "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
//       s.async = true;
//       document.body.appendChild(s);
//     }
//   }, []);

//   return (
//     <>
//       <style>{`
//         /* ── Amazon-style Mega Menu ── */
//         .mega-menu-wrapper {
//           position: relative;
//           display: inline-block;
//         }

//         .mega-menu-trigger {
//           display: flex;
//           align-items: center;
//           gap: 8px;
//           padding: 10px 18px;
//           background: #df4928;
//           color: white;
//           font-weight: 600;
//           font-size: 14px;
//           border: none;
//           cursor: pointer;
//           border-radius: 4px;
//           white-space: nowrap;
//           transition: background 0.2s;
//           height: 100%;
//         }
//         .mega-menu-trigger:hover {
//           background: #c73e20;
//         }

//         .mega-menu-panel {
//           display: none;
//           position: absolute;
//           top: calc(100% + 4px);
//           left: 0;
//           width: 680px;
//           background: white;
//           border: 1px solid #e5e7eb;
//           border-radius: 8px;
//           box-shadow: 0 8px 32px rgba(0,0,0,0.13);
//           z-index: 2000;
//           overflow: hidden;
//         }
//         .mega-menu-panel.open {
//           display: flex;
//         }

//         .mega-menu-left {
//           width: 220px;
//           min-width: 220px;
//           background: #f9fafb;
//           border-right: 1px solid #e5e7eb;
//           overflow-y: auto;
//           max-height: 420px;
//         }

//         .mega-menu-left-item {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           padding: 11px 16px;
//           font-size: 14px;
//           color: #374151;
//           cursor: pointer;
//           transition: background 0.15s, color 0.15s;
//           text-decoration: none;
//           border-bottom: 1px solid #f3f4f6;
//           font-weight: 500;
//         }
//         .mega-menu-left-item:hover,
//         .mega-menu-left-item.active {
//           background: #fff7f5;
//           color: #df4928;
//         }
//         .mega-menu-left-item.active {
//           border-right: 3px solid #df4928;
//         }

//         .mega-menu-right {
//           flex: 1;
//           padding: 16px 20px;
//           overflow-y: auto;
//           max-height: 420px;
//         }

//         .mega-menu-right h6 {
//           font-size: 13px;
//           font-weight: 700;
//           color: #df4928;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//           margin: 0 0 12px;
//           padding-bottom: 8px;
//           border-bottom: 1px solid #f3f4f6;
//         }

//         .mega-sub-grid {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 4px 12px;
//         }

//         .mega-sub-link {
//           display: block;
//           padding: 7px 10px;
//           font-size: 13px;
//           color: #374151;
//           text-decoration: none;
//           border-radius: 6px;
//           transition: background 0.15s, color 0.15s;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }
//         .mega-sub-link:hover {
//           background: #fff3f0;
//           color: #df4928;
//         }

//         .mega-view-all {
//           display: inline-block;
//           margin-top: 12px;
//           font-size: 12px;
//           color: #df4928;
//           text-decoration: none;
//           font-weight: 600;
//           border: 1px solid #df4928;
//           border-radius: 20px;
//           padding: 4px 14px;
//           transition: background 0.15s, color 0.15s;
//         }
//         .mega-view-all:hover {
//           background: #df4928;
//           color: white;
//         }

//         /* ── Horizontal Category Strip ── */
//         .category-strip {
//           background: #1a1a2e;
//           overflow: hidden;
//           white-space: nowrap;
//           position: relative;
//         }

//         .category-strip__track {
//           display: flex;
//           align-items: center;
//           min-height: 38px;
//           width: max-content;
//           will-change: transform;
//         }

//         .category-strip__track.paused {
//           animation-play-state: paused !important;
//         }

//         .category-strip__link {
//           display: inline-flex;
//           align-items: center;
//           gap: 5px;
//           padding: 8px 18px;
//           font-size: 13px;
//           color: #d1d5db;
//           text-decoration: none;
//           white-space: nowrap;
//           transition: color 0.15s, background 0.15s;
//           border-radius: 4px;
//           font-weight: 500;
//           flex-shrink: 0;
//         }
//         .category-strip__link:hover {
//           color: white;
//           background: rgba(255,255,255,0.1);
//         }
//         .category-strip__link.strip-featured {
//           color: #fbbf24;
//           font-weight: 600;
//         }
//         .category-strip__link.strip-featured:hover {
//           color: #f59e0b;
//           background: rgba(251,191,36,0.12);
//         }
//         .category-strip__divider {
//           color: rgba(255,255,255,0.15);
//           font-size: 16px;
//           padding: 0 2px;
//           user-select: none;
//           flex-shrink: 0;
//         }

//         /* Mobile Bottom Navigation Styles */
//         .mobile-bottom-nav {
//           display: none;
//         }

//         .fixed-header-middle {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           z-index: 1100;
//           animation: slideDown 0.3s ease;
//         }

//         @media (max-width: 991px) {
//           .mobile-bottom-nav {
//             display: flex;
//             position: fixed;
//             bottom: 0;
//             left: 0;
//             right: 0;
//             background: white;
//             border-top: 1px solid #e5e7eb;
//             z-index: 1000;
//             padding: 8px 0 max(8px, env(safe-area-inset-bottom));
//             box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
//           }

//           .mobile-bottom-nav__item {
//             flex: 1;
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             justify-content: center;
//             text-decoration: none;
//             color: #6b7280;
//             padding: 4px 8px;
//             position: relative;
//             transition: color 0.2s;
//           }

//           .mobile-bottom-nav__item.active {
//             color: #df4928;
//           }

//           .mobile-bottom-nav__icon {
//             font-size: 24px;
//             margin-bottom: 2px;
//           }

//           .mobile-bottom-nav__label {
//             font-size: 11px;
//             font-weight: 500;
//           }

//           .mobile-bottom-nav__badge {
//             position: absolute;
//             top: 0;
//             right: 50%;
//             transform: translateX(8px);
//             background: #df4928;
//             color: white;
//             border-radius: 10px;
//             padding: 2px 6px;
//             font-size: 10px;
//             font-weight: 600;
//             min-width: 18px;
//             text-align: center;
//           }

//           body {
//             padding-bottom: 60px;
//           }

//           .header-middle {
//             padding: 8px 0;
//           }

//           .header-middle .logo img {
//             max-height: 35px;
//           }

//           .form-location-wrapper {
//             width: 100%;
//             margin-top: 8px;
//           }

//           .location-box {
//             width: 100%;
//             flex-direction: column;
//             align-items: stretch !important;
//             padding: 12px !important;
//           }

//           .location-box > div:first-child {
//             width: 100%;
//             justify-content: center;
//             margin-bottom: 8px;
//           }

//           .location-box > div:first-child .text-gray-900 {
//             max-width: 100% !important;
//             text-align: center;
//           }

//           .location-box > div:last-child {
//             width: 100% !important;
//             margin-top: 0 !important;
//           }

//           .location-box input {
//             width: 100%;
//           }

//           .header.bg-white {
//             display: none;
//           }

//           /* category strip on mobile */
//           .category-strip {
//             display: block;
//           }

//           /* Mega menu only desktop */
//           .mega-menu-wrapper {
//             display: none;
//           }

//           .mobile-menu-drawer {
//             position: fixed;
//             top: 0;
//             left: -100%;
//             width: 80%;
//             max-width: 320px;
//             height: 100vh;
//             background: white;
//             z-index: 9999;
//             transition: left 0.3s ease;
//             overflow-y: auto;
//             box-shadow: 2px 0 10px rgba(0,0,0,0.1);
//           }

//           .mobile-menu-drawer.active {
//             left: 0;
//           }

//           .mobile-menu-overlay {
//             position: fixed;
//             top: 0;
//             left: 0;
//             right: 0;
//             bottom: 0;
//             background: rgba(0,0,0,0.5);
//             z-index: 9998;
//             opacity: 0;
//             visibility: hidden;
//             transition: all 0.3s ease;
//           }

//           .mobile-menu-overlay.active {
//             opacity: 1;
//             visibility: visible;
//           }

//           .category-modal {
//             position: fixed;
//             top: 0;
//             left: 0;
//             right: 0;
//             bottom: 0;
//             background: white;
//             z-index: 10000;
//             transform: translateY(100%);
//             transition: transform 0.3s ease;
//             display: flex;
//             flex-direction: column;
//           }

//           .category-modal.active {
//             transform: translateY(0);
//           }

//           .category-modal__header {
//             padding: 16px;
//             border-bottom: 1px solid #e5e7eb;
//             display: flex;
//             align-items: center;
//             justify-content: space-between;
//             position: sticky;
//             top: 0;
//             background: white;
//             z-index: 1;
//           }

//           .category-modal__content {
//             flex: 1;
//             overflow-y: auto;
//             padding: 16px;
//           }

//           .category-item {
//             padding: 12px 16px;
//             border-bottom: 1px solid #f3f4f6;
//             display: flex;
//             align-items: center;
//             justify-content: space-between;
//             text-decoration: none;
//             color: #374151;
//           }

//           .category-item:active {
//             background: #f9fafb;
//           }
//         }

//         @media (min-width: 992px) {
//           .mobile-only {
//             display: none !important;
//           }
//         }

//         @media (max-width: 991px) {
//           .desktop-only {
//             display: none !important;
//           }
//         }

//         .cart-badge {
//           position: absolute;
//           top: -6px;
//           right: -10px;
//           background-color: #ff3d00;
//           color: #fff;
//           font-size: 11px;
//           font-weight: 600;
//           height: 18px;
//           min-width: 18px;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 0 4px;
//         }


//         /* ── Google Translate – hide all branding ── */
// #google_translate_element .goog-te-gadget-simple {
//   border: 1px solid #e5e7eb !important;
//   border-radius: 20px !important;
//   padding: 5px 12px !important;
//   background: white !important;
//   font-size: 13px !important;
//   display: flex !important;
//   align-items: center !important;
// }

// /* Hide the Google "G" logo image */
// #google_translate_element img,
// .goog-te-gadget img,
// .goog-logo-link img {
//   display: none !important;
// }

// /* Hide "Powered by Google" link */
// .goog-te-gadget > a,
// .goog-te-gadget > span > a,
// .goog-logo-link,
// .goog-te-gadget-simple > a {
//   display: none !important;
// }

// /* Hide the "|" separator span */
// .goog-te-gadget-simple span[style*="color"],
// .goog-te-menu-value > span:not(:first-child) {
//   display: none !important;
// }

// /* Reset font size on wrapper */
// .goog-te-gadget {
//   font-size: 13px !important;
//   line-height: normal !important;
// }

// /* The actual dropdown anchor – style it clean */
// .goog-te-gadget-simple a.goog-te-menu-value {
//   color: #374151 !important;
//   text-decoration: none !important;
//   display: flex !important;
//   align-items: center !important;
//   gap: 4px !important;
//   font-size: 13px !important;
// }

// /* ── Mobile Header Fix ── */
// @media (max-width: 991px) {
  
//   /* Make the nav stack into 2 rows */
//   .header-middle .header-inner {
//     flex-wrap: wrap !important;
//     gap: 8px !important;
//     padding: 10px 0 !important;
//   }

//   /* Row 1: Logo + Translate side by side */
//   .header-middle .logo {
//     flex: 0 0 auto !important;
//   }

//   #google_translate_element {
//     flex: 0 0 auto !important;
//     margin-left: 8px !important;
//   }

//   /* Google translate widget smaller on mobile */
//   #google_translate_element .goog-te-gadget-simple {
//     padding: 4px 8px !important;
//     font-size: 12px !important;
//     border-radius: 16px !important;
//   }

//   /* Row 2: Search bar takes full width */
//   .header-middle .header-inner > div.mobile-only {
//     flex: 0 0 100% !important;
//     width: 100% !important;
//     margin-left: 0 !important;
//     order: 3 !important;
//   }

//   /* Push translate + logo to row 1, search to row 2 */
//   .header-middle .logo {
//     order: 1 !important;
//   }

//   #google_translate_element {
//     order: 2 !important;
//     margin-left: auto !important;
//   }

//   /* Cart/wishlist icons stay row 1, right side — hide on mobile since bottom nav handles it */
//   .header-middle .header-right {
//     display: none !important;
//   }

//   /* Search bar full width */
//   .header-middle .mobile-only .live-search-wrapper,
//   .header-middle .mobile-only form,
//   .header-middle .mobile-only input,
//   .header-middle .mobile-only > div {
//     width: 100% !important;
//     max-width: 100% !important;
//   }

//   /* Logo sizing */
//   .header-middle .logo img {
//     max-height: 38px !important;
//     width: auto !important;
//   }
// }



// /* Google Translate — inline in header, no fixed positioning */
// #gt-container {
//   display: flex;
//   align-items: center;
//   flex-shrink: 0;
// }

// #gt-container .goog-te-gadget-simple {
//   border: 1px solid #e5e7eb !important;
//   border-radius: 20px !important;
//   padding: 5px 12px !important;
//   background: white !important;
//   font-size: 13px !important;
//   white-space: nowrap;
// }

// #gt-container img,
// .goog-logo-link,
// .goog-te-gadget > a,
// .goog-te-gadget > span > a {
//   display: none !important;
// }

// .goog-te-gadget {
//   font-size: 13px !important;
//   line-height: normal !important;
// }

// .goog-te-gadget-simple a.goog-te-menu-value {
//   color: #374151 !important;
//   text-decoration: none !important;
//   font-size: 13px !important;
//   display: flex !important;
//   align-items: center !important;
//   gap: 4px !important;
// }





          
        

//       `}</style>

//       <div className="overlay" />
//       <div
//         className={`side-overlay ${(menuActive || activeCategory) && "show"}`}
//       />

//       {/* Mobile Menu Overlay */}
//       <div
//         className={`mobile-menu-overlay ${menuActive ? "active" : ""}`}
//         onClick={handleMenuToggle}
//       />

//       {/* Mobile Menu Drawer */}
//       <div
//         className={`mobile-menu-drawer mobile-only ${
//           menuActive ? "active" : ""
//         }`}
//       >
//         <div style={{ padding: "16px", borderBottom: "1px solid #e5e7eb" }}>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               marginBottom: "16px",
//             }}
//           >
//             <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>
//               Menu
//             </h3>
//             <button
//               onClick={handleMenuToggle}
//               style={{
//                 background: "none",
//                 border: "none",
//                 fontSize: "24px",
//                 cursor: "pointer",
//                 padding: "4px",
//               }}
//             >
//               <i className="ph ph-x" />
//             </button>
//           </div>
//           <Link
//             to={localStorage.getItem("authToken") ? "/user" : "/account"}
//             style={{ textDecoration: "none" }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "12px",
//                 padding: "12px",
//                 background: "#f9fafb",
//                 borderRadius: "8px",
//               }}
//             >
//               <div
//                 style={{
//                   width: "40px",
//                   height: "40px",
//                   borderRadius: "50%",
//                   background: "#df4928",
//                   color: "white",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: "20px",
//                 }}
//               >
//                 <i className="ph ph-user" />
//               </div>
//               <div>
//                 <div style={{ fontWeight: "600", color: "#111" }}>
//                   My Account
//                 </div>
//                 <div style={{ fontSize: "12px", color: "#6b7280" }}>
//                   View profile
//                 </div>
//               </div>
//             </div>
//           </Link>
//         </div>

//         <div style={{ padding: "8px 0" }}>
//           <Link
//             to="/"
//             onClick={handleMenuToggle}
//             style={{
//               display: "block",
//               padding: "12px 16px",
//               textDecoration: "none",
//               color: "#374151",
//               borderBottom: "1px solid #f3f4f6",
//             }}
//           >
//             <i
//               className="ph ph-house"
//               style={{ marginRight: "12px", fontSize: "18px" }}
//             />
//             Home
//           </Link>
//           <Link
//             to="/shop"
//             onClick={handleMenuToggle}
//             style={{
//               display: "block",
//               padding: "12px 16px",
//               textDecoration: "none",
//               color: "#374151",
//               borderBottom: "1px solid #f3f4f6",
//             }}
//           >
//             <i
//               className="ph ph-shopping-bag"
//               style={{ marginRight: "12px", fontSize: "18px" }}
//             />
//             All Products
//           </Link>
//           <Link
//             to="/wishlist"
//             onClick={handleMenuToggle}
//             style={{
//               display: "block",
//               padding: "12px 16px",
//               textDecoration: "none",
//               color: "#374151",
//               borderBottom: "1px solid #f3f4f6",
//             }}
//           >
//             <i
//               className="ph ph-heart"
//               style={{ marginRight: "12px", fontSize: "18px" }}
//             />
//             Wishlist
//           </Link>
//           <Link
//             to="/cart-one"
//             onClick={handleMenuToggle}
//             style={{
//               display: "block",
//               padding: "12px 16px",
//               textDecoration: "none",
//               color: "#374151",
//               borderBottom: "1px solid #f3f4f6",
//             }}
//           >
//             <i
//               className="ph ph-shopping-cart"
//               style={{ marginRight: "12px", fontSize: "18px" }}
//             />
//             Cart
//           </Link>
//         </div>

//         <div style={{ padding: "16px", borderTop: "1px solid #e5e7eb" }}>
//           <div style={{ marginBottom: "12px" }}>
//             <div
//               style={{
//                 fontSize: "12px",
//                 color: "#6b7280",
//                 marginBottom: "8px",
//               }}
//             >
//               Currency
//             </div>
//             <select
//               value={selectedCurrency}
//               onChange={(e) => handleCurrencyChange(e.target.value)}
//               style={{
//                 width: "100%",
//                 padding: "8px",
//                 borderRadius: "6px",
//                 border: "1px solid #e5e7eb",
//               }}
//             >
//               <option value="INR">INR - Indian Rupee</option>
//               <option value="USD">USD - US Dollar</option>
//               <option value="EUR">EUR - Euro</option>
//               <option value="AED">AED - Dirham</option>
//             </select>
//           </div>

//           <Link
//             to="/become-seller"
//             onClick={handleMenuToggle}
//             style={{
//               display: "block",
//               padding: "12px",
//               background: "#df4928",
//               color: "white",
//               textAlign: "center",
//               borderRadius: "6px",
//               textDecoration: "none",
//               marginTop: "16px",
//             }}
//           >
//             Become A Seller
//           </Link>

//           <Link
//             to="https://tawk.to/chat/692acad3d7e07b1987ebcec7/1jb7igj0b"
//             onClick={handleMenuToggle}
//             style={{
//               display: "block",
//               padding: "12px",
//               background: "#df4928",
//               color: "white",
//               textAlign: "center",
//               borderRadius: "6px",
//               textDecoration: "none",
//               marginTop: "16px",
//             }}
//           >
//             Help Center - Live Chat
//           </Link>
//         </div>
//       </div>

//       {/* Category Modal (mobile) */}
//       <div
//         className={`category-modal mobile-only ${
//           activeCategory ? "active" : ""
//         }`}
//       >
//         <div className="category-modal__header">
//           <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>
//             All Categories
//           </h3>
//           <button
//             onClick={handleCategoryToggle}
//             style={{
//               background: "none",
//               border: "none",
//               fontSize: "24px",
//               cursor: "pointer",
//               padding: "4px",
//             }}
//           >
//             <i className="ph ph-x" />
//           </button>
//         </div>
//         <div className="category-modal__content">
//           {categories.map((cat) => (
//             <Link
//               key={cat._id}
//               to={`/product-list-one?category=${cat._id}`}
//               className="category-item"
//               onClick={handleCategoryToggle}
//             >
//               <span>{cat.name}</span>
//               <i className="ph ph-caret-right" />
//             </Link>
//           ))}
//         </div>
//       </div>

//       {/* Search Box */}
//       <form action="#" className={`search-box ${activeSearch && "active"}`}>
//         <button
//           onClick={handleSearchToggle}
//           type="button"
//           className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1"
//         >
//           <i className="ph ph-x" />
//         </button>
//         <div className="container">
//           <div className="position-relative">
//             <input
//               type="text"
//               className="form-control py-16 px-24 text-xl rounded-pill pe-64"
//               placeholder="Search for a product or brand"
//             />
//             <button
//               type="submit"
//               className="w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
//             >
//               <i className="ph ph-magnifying-glass" />
//             </button>
//           </div>
//         </div>
//       </form>

//       {/* Top Header Bar */}
//       <div className="header-top bg-main-600 flex-between desktop-only">
//         <div className="container container-lg">
//           <div className="flex-between flex-wrap gap-8">
//             <ul className="flex-align flex-wrap d-none d-md-flex">
//               <li className="border-right-item">
//                 <Link
//                   to="/become-seller"
//                   className="text-white text-sm hover-text-decoration-underline"
//                 >
//                   Become A Seller
//                 </Link>
//               </li>
//               <li className="border-right-item">
//                 <Link
//                   to="/about-us"
//                   className="text-white text-sm hover-text-decoration-underline"
//                 >
//                   About us
//                 </Link>
//               </li>
//               <li className="border-right-item">
//                 <Link
//                   to="/privacy-policy"
//                   className="text-white text-sm hover-text-decoration-underline"
//                 >
//                   Privacy Policy
//                 </Link>
//               </li>
//             </ul>
//             <ul className="header-top__right flex-align flex-wrap">
//               <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
//                 <Link to="#" className="text-white text-sm py-8">
//                   Help Center
//                 </Link>
//                 <ul className="on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
//                   <li className="nav-submenu__item">
//                     <Link
//                       to="https://tawk.to/chat/692acad3d7e07b1987ebcec7/1jb7igj0b"
//                       className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
//                     >
//                       <span className="text-sm d-flex">
//                         <i className="ph ph-chat-circle-dots" />
//                       </span>
//                       Live Chat
//                     </Link>
//                   </li>
//                 </ul>
//               </li>
//               <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
//                 <Link to="#" className="selected-text text-white text-sm py-8">
//                   {selectedCurrency}
//                 </Link>
//                 <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
//                   <li>
//                     <Link
//                       to="#"
//                       className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
//                       onClick={() => handleCurrencyChange("INR")}
//                     >
//                       <img
//                         src="https://flagsapi.com/IN/flat/64.png"
//                         alt="INR"
//                         className="w-16 h-12 rounded-4 border border-gray-100"
//                       />
//                       INR
//                     </Link>
//                   </li>
//                   <li>
//                     <Link
//                       to="#"
//                       className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
//                       onClick={() => handleCurrencyChange("USD")}
//                     >
//                       <img
//                         src="https://flagsapi.com/US/flat/64.png"
//                         alt="USD"
//                         className="w-16 h-12 rounded-4 border border-gray-100"
//                       />
//                       USD
//                     </Link>
//                   </li>
//                   <li>
//                     <Link
//                       to="#"
//                       className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
//                       onClick={() => handleCurrencyChange("EUR")}
//                     >
//                       <img
//                         src="https://flagsapi.com/FR/flat/64.png"
//                         alt="EUR"
//                         className="w-16 h-12 rounded-4 border border-gray-100"
//                       />
//                       EUR
//                     </Link>
//                   </li>
//                   <li>
//                     <Link
//                       to="#"
//                       className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
//                       onClick={() => handleCurrencyChange("AED")}
//                     >
//                       <img
//                         src="https://flagsapi.com/AE/flat/64.png"
//                         alt="AED"
//                         className="w-16 h-12 rounded-4 border border-gray-100"
//                       />
//                       AED
//                     </Link>
//                   </li>
//                 </ul>
//               </li>
//               <li className="border-right-item">
//                 <Link
//                   to={localStorage.getItem("authToken") ? "/user" : "/account"}
//                   className="text-white text-sm py-8 flex-align gap-6"
//                 >
//                   <span className="icon text-md d-flex">
//                     <i className="ph ph-user-circle" />
//                   </span>
//                   <span className="hover-text-decoration-underline">
//                     My Account
//                   </span>
//                 </Link>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>

//       {/* Middle Header */}
//       <header
//         className={`header-middle bg-color-one border-gray-100 ${
//           scroll && "fixed-header-middle"
//         }`}
//       >
//         <div className="container container-lg">
//           <nav className="header-inner flex-between">
//             <div className="logo">
//               <Link to="/" className="link">
//                 <img src="/assets/images/logo/logo.png" alt="Logo" />
//               </Link>
//             </div>

//             {/* GOOGLE TRANSLATE WIDGET */}
//             <div id="gt-container" style={{ flexShrink: 0 }}></div>

//             <div
//               className="desktop-only"
//               style={{ flex: 1, marginLeft: "20px" }}
//             >
//               <LiveSearch />
//             </div>

//             <div
//               className="mobile-only"
//               style={{ flex: 1, marginLeft: "20px" }}
//             >
//               <LiveSearch />
//             </div>
//             <form
//               action="#"
//               className="flex-align flex-wrap form-location-wrapper desktop-only px-40 "
//             >
//               <div className="location-box bg-white flex-align gap-8 py-6 px-16 rounded-pill border border-gray-100 ms-10">
//                 <span className="text-gray-900 text-xl d-xs-flex d-none">
//                   <i className="ph ph-map-pin" />
//                 </span>

//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     flex: 1,
//                   }}
//                 >
//                   <div
//                     className="text-gray-900 fw-medium"
//                     title={location.display}
//                     style={{
//                       whiteSpace: "nowrap",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       maxWidth: "250px",
//                     }}
//                   >
//                     {location.display}
//                   </div>
//                 </div>

//                 <div
//                   style={{
//                     position: "relative",
//                     marginTop: 0,
//                     marginRight: -6,
//                     width: "180px",
//                   }}
//                 >
//                   <input
//                     type="text"
//                     placeholder="Search city or place..."
//                     value={search}
//                     onChange={(e) => setSearch(e.target.value)}
//                     className="form-control"
//                     style={{
//                       borderRadius: 20,
//                       padding: "6px 10px",
//                       fontSize: 13,
//                     }}
//                   />
//                   {loading && (
//                     <div className="text-muted small mt-1">Searching…</div>
//                   )}

//                   {suggestions.length > 0 && (
//                     <ul
//                       style={{
//                         position: "absolute",
//                         zIndex: 1000,
//                         background: "white",
//                         border: "1px solid #ddd",
//                         borderRadius: 8,
//                         width: "100%",
//                         maxHeight: 200,
//                         overflowY: "auto",
//                         marginTop: 4,
//                         listStyle: "none",
//                         padding: 0,
//                       }}
//                     >
//                       {suggestions.map((s) => (
//                         <li
//                           key={s.id}
//                           onClick={() => handleSelectSuggestion(s)}
//                           style={{ padding: "8px 10px", cursor: "pointer" }}
//                           className="hover:bg-light"
//                         >
//                           <div
//                             style={{
//                               fontSize: 13,
//                               color: "#111",
//                               whiteSpace: "nowrap",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                             }}
//                           >
//                             {s.display}
//                           </div>
//                           <div style={{ fontSize: 11, color: "#666" }}>
//                             {[s.city, s.state, s.country]
//                               .filter(Boolean)
//                               .join(", ")}
//                           </div>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>
//               </div>
//             </form>

//             <div className="header-right flex-align d-lg-block d-none">
//               <div className="flex-align flex-wrap gap-12">
//                 <Link to="/wishlist" className="flex-align gap-4 item-hover">
//                   <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
//                     <i className="ph ph-heart" />
//                   </span>
//                 </Link>
//                 <Link
//                   to="/cart-one"
//                   className="flex-align gap-4 item-hover position-relative"
//                 >
//                   <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
//                     <i className="ph ph-shopping-cart-simple" />
//                     {cartCount > 0 && (
//                       <span className="cart-badge">{cartCount}</span>
//                     )}
//                   </span>
//                 </Link>
//               </div>
//             </div>
//           </nav>
//         </div>
//       </header>

//       {/* ── Desktop Navigation Header (unchanged original) ── */}
//       <header
//         className={`header bg-white border-bottom border-gray-100 desktop-only`}
//       >
//         <div className="container container-lg">
//           <nav className="header-inner d-flex justify-content-between gap-8">
//             <div className="flex-align menu-category-wrapper">
//               {/* ── REPLACED: Amazon-style Mega Menu button (replaces old category dropdown) ── */}
//               <div
//                 className="mega-menu-wrapper"
//                 onMouseEnter={handleMegaMouseEnter}
//                 onMouseLeave={handleMegaMouseLeave}
//                 ref={megaMenuRef}
//               >
//                 <button type="button" className="mega-menu-trigger">
//                   <span style={{ fontSize: "18px", display: "flex" }}>
//                     <i className="ph ph-dots-nine" />
//                   </span>
//                   All Categories
//                   <span style={{ fontSize: "14px", display: "flex" }}>
//                     <i className="ph ph-caret-down" />
//                   </span>
//                 </button>

//                 {/* Mega Menu Panel */}
//                 <div
//                   className={`mega-menu-panel ${megaMenuOpen ? "open" : ""}`}
//                 >
//                   {/* Left: category list */}
//                   <div className="mega-menu-left">
//                     {categories.map((cat) => (
//                       <div
//                         key={cat._id}
//                         className={`mega-menu-left-item ${
//                           megaHoveredCat?._id === cat._id ? "active" : ""
//                         }`}
//                         onMouseEnter={() => handleMegaCatHover(cat)}
//                       >
//                         <span>{cat.name}</span>
//                         <i
//                           className="ph ph-caret-right"
//                           style={{ fontSize: "12px", opacity: 0.5 }}
//                         />
//                       </div>
//                     ))}
//                   </div>

//                   {/* Right: subcategory grid */}
//                   <div className="mega-menu-right">
//                     {megaHoveredCat && (
//                       <>
//                         <h6>{megaHoveredCat.name}</h6>
//                         {subcategories[megaHoveredCat._id]?.length > 0 ? (
//                           <>
//                             <div className="mega-sub-grid">
//                               {subcategories[megaHoveredCat._id].map((sub) => (
//                                 <Link
//                                   key={sub._id}
//                                   to={`/product-list-one?category=${megaHoveredCat._id}&subcategory=${sub._id}`}
//                                   className="mega-sub-link"
//                                   onClick={() => setMegaMenuOpen(false)}
//                                 >
//                                   <i
//                                     className="ph ph-tag"
//                                     style={{
//                                       marginRight: "6px",
//                                       fontSize: "11px",
//                                       opacity: 0.5,
//                                     }}
//                                   />
//                                   {sub.name}
//                                 </Link>
//                               ))}
//                             </div>
//                             <Link
//                               to={`/product-list-one?category=${megaHoveredCat._id}`}
//                               className="mega-view-all"
//                               onClick={() => setMegaMenuOpen(false)}
//                             >
//                               View all in {megaHoveredCat.name} →
//                             </Link>
//                           </>
//                         ) : (
//                           <div style={{ fontSize: "13px", color: "#9ca3af" }}>
//                             Loading subcategories…
//                           </div>
//                         )}
//                       </>
//                     )}
//                   </div>
//                 </div>
//               </div>
//               {/* ── END Mega Menu ── */}

//               <div className="header-menu d-lg-block d-none">
//                 <ul className="nav-menu flex-align">
//                   <li className="nav-menu__item">
//                     <NavLink
//                       to="/"
//                       className={(navData) =>
//                         navData.isActive
//                           ? "nav-menu__link activePage"
//                           : "nav-menu__link"
//                       }
//                     >
//                       Home
//                     </NavLink>
//                   </li>
//                   <li className="nav-menu__item">
//                     <NavLink
//                       to="/shop"
//                       className={(navData) =>
//                         navData.isActive
//                           ? "nav-menu__link activePage"
//                           : "nav-menu__link"
//                       }
//                     >
//                       All Products
//                     </NavLink>
//                   </li>
//                 </ul>
//               </div>
//             </div>

//             <div className="header-right flex-align">
//               <Link
//                 to="tel:+919993553538"
//                 className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none"
//               >
//                 <div className="d-flex text-32">
//                   <i className="ph ph-phone-call" />
//                 </div>
//                 +91 9993553538
//               </Link>
//             </div>
//           </nav>
//         </div>
//       </header>

//       {/* ── Infinite Auto-Scrolling Category Strip ── */}
//       <div className="category-strip">
//         <InfiniteStripScroller categories={categories} />
//       </div>

//       {/* Mobile Bottom Navigation */}
//       <nav className="mobile-bottom-nav">
//         <button onClick={handleMenuToggle} className="mobile-bottom-nav__item">
//           <i className="ph-fill ph-list mobile-bottom-nav__icon" />
//           <span className="mobile-bottom-nav__label">Menu</span>
//         </button>

//         <NavLink
//           to="/shop"
//           className={({ isActive }) =>
//             isActive
//               ? "mobile-bottom-nav__item active"
//               : "mobile-bottom-nav__item"
//           }
//         >
//           <i className="ph-fill ph-shopping-bag mobile-bottom-nav__icon" />
//           <span className="mobile-bottom-nav__label">Products</span>
//         </NavLink>

//         <NavLink
//           to="/"
//           className={({ isActive }) =>
//             isActive
//               ? "mobile-bottom-nav__item active"
//               : "mobile-bottom-nav__item"
//           }
//         >
//           <i className="ph-fill ph-house mobile-bottom-nav__icon" />
//           <span className="mobile-bottom-nav__label">Home</span>
//         </NavLink>

//         <button
//           onClick={handleCategoryToggle}
//           className="mobile-bottom-nav__item"
//         >
//           <i className="ph-fill ph-squares-four mobile-bottom-nav__icon" />
//           <span className="mobile-bottom-nav__label">Category</span>
//         </button>

//         <NavLink
//           to="/cart-one"
//           className={({ isActive }) =>
//             isActive
//               ? "mobile-bottom-nav__item active"
//               : "mobile-bottom-nav__item"
//           }
//         >
//           <i className="ph-fill ph-shopping-cart mobile-bottom-nav__icon" />
//           <span className="mobile-bottom-nav__label">Cart</span>
//         </NavLink>
//       </nav>
//     </>
//   );
// };

// export default HeaderOne;




// import React, { useEffect, useState, useRef } from "react";
// import { Link, NavLink, useNavigate } from "react-router-dom";
// import axios from "axios";
// import LiveSearch from "./LiveSearch/LiveSearch";

// const NOMINATIM_BASE = "https://nominatim.openstreetmap.org";

// /* ── Netflix-style Infinite Scrolling Strip ── */
// const InfiniteStripScroller = ({ categories }) => {
//   const trackRef = useRef(null);
//   const animFrameRef = useRef(null);
//   const posRef = useRef(0);
//   const pausedRef = useRef(true);
//   const halfWidthRef = useRef(0);
//   const startDelayRef = useRef(null);

//   const items = [
//     { id: "__deals__", name: "Deals", to: "/shop", featured: true, icon: "ph ph-fire" },
//     ...categories.map((c) => ({ id: c._id, name: c.name, to: `/product-list-one?category=${c._id}` })),
//     { id: "__seller__", name: "Sell with us", to: "/become-seller", icon: "ph ph-storefront" },
//   ];

//   const allItems = [...items, ...items];

//   useEffect(() => {
//     if (!trackRef.current || items.length === 0) return;

//     const measure = () => {
//       const fullWidth = trackRef.current?.scrollWidth || 0;
//       halfWidthRef.current = fullWidth / 2;
//     };
//     const frame = requestAnimationFrame(measure);

//     startDelayRef.current = setTimeout(() => {
//       pausedRef.current = false;
//     }, 1000);

//     const SPEED = 0.6;
//     const tick = () => {
//       if (!pausedRef.current && trackRef.current && halfWidthRef.current > 0) {
//         posRef.current += SPEED;
//         if (posRef.current >= halfWidthRef.current) posRef.current = 0;
//         trackRef.current.style.transform = `translateX(-${posRef.current}px)`;
//       }
//       animFrameRef.current = requestAnimationFrame(tick);
//     };
//     animFrameRef.current = requestAnimationFrame(tick);

//     return () => {
//       cancelAnimationFrame(frame);
//       cancelAnimationFrame(animFrameRef.current);
//       clearTimeout(startDelayRef.current);
//     };
//   }, [categories]);

//   const handleMouseEnter = () => { pausedRef.current = true; };
//   const handleMouseLeave = () => { pausedRef.current = false; };

//   if (categories.length === 0) return null;

//   return (
//     <div style={{ overflow: "hidden", width: "100%" }} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
//       <div ref={trackRef} className="category-strip__track">
//         {allItems.map((item, idx) => (
//           <React.Fragment key={`${item.id}-${idx}`}>
//             <Link to={item.to} className={`category-strip__link${item.featured ? " strip-featured" : ""}`}>
//               {item.icon && <i className={item.icon} style={{ fontSize: "13px" }} />}
//               {item.name}
//             </Link>
//             <span className="category-strip__divider">·</span>
//           </React.Fragment>
//         ))}
//       </div>
//     </div>
//   );
// };

// const HeaderOne = () => {
//   const [scroll, setScroll] = useState(false);
//   const [location, setLocation] = useState({ display: "Detecting...", city: "", state: "", country: "" });
//   const [search, setSearch] = useState("");
//   const [suggestions, setSuggestions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const abortRef = useRef(null);
//   const debounceRef = useRef(null);

//   useEffect(() => {
//     const onScroll = () => setScroll(window.pageYOffset > 150);
//     window.addEventListener("scroll", onScroll);
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   const fetchCurrentLocation = () => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(
//         async (pos) => {
//           const { latitude, longitude } = pos.coords;
//           try {
//             const res = await fetch(`${NOMINATIM_BASE}/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`);
//             const data = await res.json();
//             const addr = data.address || {};
//             const city = addr.city || addr.town || addr.village || addr.county || "";
//             const state = addr.state || "";
//             const country = addr.country || "";
//             setLocation({ display: [city, state, country].filter(Boolean).join(", "), city, state, country });
//           } catch {
//             setLocation({ display: "Unable to fetch location", city: "", state: "", country: "" });
//           }
//         },
//         () => setLocation({ display: "Location not available", city: "", state: "", country: "" }),
//       );
//     } else {
//       setLocation({ display: "Geolocation not supported", city: "", state: "", country: "" });
//     }
//   };

//   useEffect(() => { fetchCurrentLocation(); }, []);

//   useEffect(() => {
//     if (!search || search.length < 2) { setSuggestions([]); return; }
//     if (debounceRef.current) clearTimeout(debounceRef.current);
//     debounceRef.current = setTimeout(async () => {
//       setLoading(true);
//       if (abortRef.current) abortRef.current.abort();
//       abortRef.current = new AbortController();
//       try {
//         const res = await fetch(
//           `${NOMINATIM_BASE}/search?q=${encodeURIComponent(search)}&format=json&addressdetails=1&limit=5`,
//           { signal: abortRef.current.signal },
//         );
//         const results = await res.json();
//         const sug = results.map((r) => {
//           const addr = r.address || {};
//           const city = addr.city || addr.town || addr.village || addr.county || "";
//           const state = addr.state || "";
//           const country = addr.country || "";
//           return { id: r.place_id, display: r.display_name, city, state, country };
//         });
//         setSuggestions(sug);
//       } catch { setSuggestions([]); }
//       finally { setLoading(false); }
//     }, 400);
//     return () => clearTimeout(debounceRef.current);
//   }, [search]);

//   const handleSelectSuggestion = (s) => {
//     setLocation({ display: [s.city, s.state, s.country].filter(Boolean).join(", "), city: s.city, state: s.state, country: s.country });
//     setSearch("");
//     setSuggestions([]);
//   };

//   const [selectedCurrency, setSelectedCurrency] = useState(localStorage.getItem("selectedCurrency") || "INR");

//   useEffect(() => {
//     const saved = localStorage.getItem("selectedCurrency");
//     if (!saved) {
//       localStorage.setItem("selectedCurrency", "INR");
//       setSelectedCurrency("INR");
//       window.location.reload();
//     }
//   }, []);

//   const handleCurrencyChange = (currency) => {
//     setSelectedCurrency(currency);
//     localStorage.setItem("selectedCurrency", currency);
//     window.location.reload();
//   };

//   const [menuActive, setMenuActive] = useState(false);
//   const [activeIndex, setActiveIndex] = useState(null);
//   const handleMenuToggle = () => setMenuActive(!menuActive);

//   const [activeSearch, setActiveSearch] = useState(false);
//   const handleSearchToggle = () => setActiveSearch(!activeSearch);

//   const navigate = useNavigate();
//   const [categories, setCategories] = useState([]);
//   const [activeIndexCat, setActiveIndexCat] = useState(null);
//   const [subcategories, setSubcategories] = useState({});
//   const [activeCategory, setActiveCategory] = useState(false);
//   const [cartCount, setCartCount] = useState(0);

//   const [megaMenuOpen, setMegaMenuOpen] = useState(false);
//   const [megaHoveredCat, setMegaHoveredCat] = useState(null);
//   const megaMenuRef = useRef(null);
//   const megaLeaveTimer = useRef(null);

//   const handleMegaMouseEnter = () => {
//     if (megaLeaveTimer.current) clearTimeout(megaLeaveTimer.current);
//     setMegaMenuOpen(true);
//     if (categories.length > 0 && !megaHoveredCat) setMegaHoveredCat(categories[0]);
//   };

//   const handleMegaMouseLeave = () => {
//     megaLeaveTimer.current = setTimeout(() => {
//       setMegaMenuOpen(false);
//       setMegaHoveredCat(null);
//     }, 150);
//   };

//   const handleMegaCatHover = async (cat) => {
//     setMegaHoveredCat(cat);
//     if (subcategories[cat._id]) return;
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}/subcategory/category/${cat._id}`);
//       if (response.data.success) setSubcategories((prev) => ({ ...prev, [cat._id]: response.data.data }));
//     } catch (error) { console.error("Error fetching subcategories:", error); }
//   };

//   const handleCategoryToggle = () => setActiveCategory(!activeCategory);

//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API_URL}/category/all`);
//         setCategories(res.data.data);
//         if (res.data.data.length > 0) setMegaHoveredCat(res.data.data[0]);
//       } catch (err) { console.error("Error fetching categories:", err); }
//     };
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     const cartRaw = localStorage.getItem("cart");
//     const cart = cartRaw ? JSON.parse(cartRaw) : [];
//     setCartCount(cart.length);
//   }, []);

//   // ── Google Translate: single init, outside React tree ──
//   // useEffect(() => {
//   //   if (window.__gtInitialized) return;
//   //   window.__gtInitialized = true;

//   //   window.googleTranslateElementInit = () => {
//   //     try {
//   //       new window.google.translate.TranslateElement(
//   //         {
//   //           pageLanguage: "en",
//   //           includedLanguages: "en,hi,mr,ur,ar,bn,ta,te,kn,ml,gu,pa,or,as,fr,de,es,it,pt,ru,zh-CN,ja,ko,tr,nl,pl,sv,th,vi,id",
//   //           layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
//   //           autoDisplay: false,
//   //         },
//   //         "gt-widget"
//   //       );
//   //       setTimeout(() => {
//   //         document.querySelectorAll(".goog-logo-link").forEach((el) => el.remove());
//   //         document.querySelectorAll(".goog-te-gadget").forEach((gadget) => {
//   //           gadget.childNodes.forEach((node) => {
//   //             if (node.nodeType === Node.TEXT_NODE) node.remove();
//   //             if (node.nodeName === "SPAN" && node.querySelector?.("a")) node.remove();
//   //           });
//   //         });
//   //       }, 800);
//   //     } catch (e) {
//   //       console.warn("GT init failed", e);
//   //     }
//   //   };

//   //   if (!document.getElementById("gt-script")) {
//   //     const s = document.createElement("script");
//   //     s.id = "gt-script";
//   //     s.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
//   //     s.async = true;
//   //     document.body.appendChild(s);
//   //   }
//   // }, []);
//   useEffect(() => {
//   const isMobile = window.innerWidth < 992;
//   const containerId = isMobile ? "gt-widget-mobile" : "gt-widget";

//   const initTranslate = () => {
//     try {
//       new window.google.translate.TranslateElement(
//         {
//           pageLanguage: "en",
//           includedLanguages: "en,hi,mr,ur,ar,bn,ta,te,kn,ml,gu,pa,or,as,fr,de,es,it,pt,ru,zh-CN,ja,ko,tr,nl,pl,sv,th,vi,id",
//           layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
//           autoDisplay: false,
//         },
//         containerId
//       );
//       setTimeout(() => {
//         document.querySelectorAll(".goog-logo-link").forEach((el) => el.remove());
//         document.querySelectorAll(".goog-te-gadget").forEach((gadget) => {
//           gadget.childNodes.forEach((node) => {
//             if (node.nodeType === Node.TEXT_NODE) node.remove();
//             if (node.nodeName === "SPAN" && node.querySelector?.("a")) node.remove();
//           });
//         });
//       }, 800);
//     } catch (e) {
//       console.warn("GT init failed", e);
//     }
//   };

//   const waitForContainer = (callback) => {
//     const el = document.getElementById(containerId);
//     if (el) { callback(); return; }
//     const interval = setInterval(() => {
//       if (document.getElementById(containerId)) {
//         clearInterval(interval);
//         callback();
//       }
//     }, 50);
//     setTimeout(() => clearInterval(interval), 5000);
//   };

//   const reinjectIfNeeded = () => {
//     const containerId2 = (window.innerWidth < 992) ? "gt-widget-mobile" : "gt-widget";
//     const container = document.getElementById(containerId2);
//     // If container exists but is empty — Google Translate disappeared, re-inject
//     if (container && !container.querySelector(".goog-te-gadget")) {
//       try {
//         new window.google.translate.TranslateElement(
//           {
//             pageLanguage: "en",
//             includedLanguages: "en,hi,mr,ur,ar,bn,ta,te,kn,ml,gu,pa,or,as,fr,de,es,it,pt,ru,zh-CN,ja,ko,tr,nl,pl,sv,th,vi,id",
//             layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
//             autoDisplay: false,
//           },
//           containerId2
//         );
//       } catch (e) {}
//     }
//   };

//   if (window.google?.translate?.TranslateElement) {
//     // Script already loaded — just re-inject into container if empty
//     waitForContainer(reinjectIfNeeded);
//   } else {
//     // First load — inject script
//     window.googleTranslateElementInit = () => {
//       waitForContainer(initTranslate);
//     };
//     if (!document.getElementById("gt-script")) {
//       const s = document.createElement("script");
//       s.id = "gt-script";
//       s.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
//       s.async = true;
//       document.body.appendChild(s);
//     }
//   }

  
// }, []);

//   return (
//     <>
//       <style>{`
//         /* ── Mega Menu ── */
//         .mega-menu-wrapper { position: relative; display: inline-block; }
//         .mega-menu-trigger {
//           display: flex; align-items: center; gap: 8px; padding: 10px 18px;
//           background: #df4928; color: white; font-weight: 600; font-size: 14px;
//           border: none; cursor: pointer; border-radius: 4px; white-space: nowrap;
//           transition: background 0.2s; height: 100%;
//         }
//         .mega-menu-trigger:hover { background: #c73e20; }
//         .mega-menu-panel {
//           display: none; position: absolute; top: calc(100% + 4px); left: 0;
//           width: 680px; background: white; border: 1px solid #e5e7eb;
//           border-radius: 8px; box-shadow: 0 8px 32px rgba(0,0,0,0.13);
//           z-index: 2000; overflow: hidden;
//         }
//         .mega-menu-panel.open { display: flex; }
//         .mega-menu-left {
//           width: 220px; min-width: 220px; background: #f9fafb;
//           border-right: 1px solid #e5e7eb; overflow-y: auto; max-height: 420px;
//         }
//         .mega-menu-left-item {
//           display: flex; align-items: center; justify-content: space-between;
//           padding: 11px 16px; font-size: 14px; color: #374151; cursor: pointer;
//           transition: background 0.15s, color 0.15s; text-decoration: none;
//           border-bottom: 1px solid #f3f4f6; font-weight: 500;
//         }
//         .mega-menu-left-item:hover, .mega-menu-left-item.active { background: #fff7f5; color: #df4928; }
//         .mega-menu-left-item.active { border-right: 3px solid #df4928; }
//         .mega-menu-right { flex: 1; padding: 16px 20px; overflow-y: auto; max-height: 420px; }
//         .mega-menu-right h6 {
//           font-size: 13px; font-weight: 700; color: #df4928; text-transform: uppercase;
//           letter-spacing: 0.5px; margin: 0 0 12px; padding-bottom: 8px; border-bottom: 1px solid #f3f4f6;
//         }
//         .mega-sub-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4px 12px; }
//         .mega-sub-link {
//           display: block; padding: 7px 10px; font-size: 13px; color: #374151;
//           text-decoration: none; border-radius: 6px; transition: background 0.15s, color 0.15s;
//           white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//         }
//         .mega-sub-link:hover { background: #fff3f0; color: #df4928; }
//         .mega-view-all {
//           display: inline-block; margin-top: 12px; font-size: 12px; color: #df4928;
//           text-decoration: none; font-weight: 600; border: 1px solid #df4928;
//           border-radius: 20px; padding: 4px 14px; transition: background 0.15s, color 0.15s;
//         }
//         .mega-view-all:hover { background: #df4928; color: white; }

//         /* ── Category Strip ── */
//         .category-strip { background: #1a1a2e; overflow: hidden; white-space: nowrap; position: relative; }
//         .category-strip__track { display: flex; align-items: center; min-height: 38px; width: max-content; will-change: transform; }
//         .category-strip__link {
//           display: inline-flex; align-items: center; gap: 5px; padding: 8px 18px;
//           font-size: 13px; color: #d1d5db; text-decoration: none; white-space: nowrap;
//           transition: color 0.15s, background 0.15s; border-radius: 4px; font-weight: 500; flex-shrink: 0;
//         }
//         .category-strip__link:hover { color: white; background: rgba(255,255,255,0.1); }
//         .category-strip__link.strip-featured { color: #fbbf24; font-weight: 600; }
//         .category-strip__link.strip-featured:hover { color: #f59e0b; background: rgba(251,191,36,0.12); }
//         .category-strip__divider { color: rgba(255,255,255,0.15); font-size: 16px; padding: 0 2px; user-select: none; flex-shrink: 0; }

//         /* ── Google Translate Widget ── */
//         #gt-widget {
//           display: flex;
//           align-items: center;
//           flex-shrink: 0;
//         }
//         #gt-widget .goog-te-gadget-simple {
//           border: 1px solid #e5e7eb !important;
//           border-radius: 20px !important;
//           padding: 5px 12px !important;
//           background: white !important;
//           font-size: 13px !important;
//           white-space: nowrap !important;
//           cursor: pointer !important;
//         }
//         #gt-widget img,
//         .goog-logo-link,
//         .goog-te-gadget > a,
//         .goog-te-gadget > span > a { display: none !important; }
//         .goog-te-gadget { font-size: 13px !important; line-height: normal !important; }
//         .goog-te-gadget-simple a.goog-te-menu-value {
//           color: #374151 !important; text-decoration: none !important;
//           font-size: 13px !important; display: flex !important;
//           align-items: center !important; gap: 4px !important;
//         }
//         .goog-te-menu-value span:last-child { display: none !important; }

//         /* Mobile drawer translate */
//         #gt-widget-mobile .goog-te-gadget-simple {
//           border: 1px solid #e5e7eb !important;
//           border-radius: 8px !important;
//           padding: 8px 12px !important;
//           background: white !important;
//           font-size: 13px !important;
//           width: 100% !important;
//           display: flex !important;
//           cursor: pointer !important;
//         }
//         #gt-widget-mobile img,
//         #gt-widget-mobile .goog-logo-link { display: none !important; }
//         #gt-widget-mobile .goog-te-gadget-simple a.goog-te-menu-value {
//           color: #374151 !important; text-decoration: none !important;
//           font-size: 13px !important; width: 100% !important;
//         }

//         /* ── Fixed header on scroll ── */
//         .fixed-header-middle {
//           position: fixed; top: 0; left: 0; right: 0; z-index: 1100;
//           animation: slideDown 0.3s ease;
//         }

//         /* ── Cart badge ── */
//         .cart-badge {
//           position: absolute; top: -6px; right: -10px;
//           background-color: #ff3d00; color: #fff; font-size: 11px; font-weight: 600;
//           height: 18px; min-width: 18px; border-radius: 50%;
//           display: flex; align-items: center; justify-content: center; padding: 0 4px;
//         }

//         /* ── Desktop/Mobile visibility ── */
//         @media (min-width: 992px) { .mobile-only { display: none !important; } }
//         @media (max-width: 991px) { .desktop-only { display: none !important; } }

//         /* ── Mobile Bottom Nav ── */
//         .mobile-bottom-nav { display: none; }

//         @media (max-width: 991px) {
//           body { padding-bottom: 60px; }

//           /* Mobile header — 2 rows */
//           .header-middle { padding: 8px 0; }
//           .header-middle .header-inner {
//             flex-wrap: wrap !important;
//             align-items: center !important;
//             gap: 0 !important;
//           }

//           /* Row 1: Logo left, translate right */
//           .header-middle .logo {
//             order: 1;
//             flex: 0 0 auto;
//           }
//           #gt-widget {
//             order: 2;
//             margin-left: auto;
//             flex-shrink: 0;
//           }
//           /* Hide desktop gt-widget on mobile — shown in drawer instead */
//           #gt-widget { display: none !important; }

//           /* Row 2: Search full width */
//           .header-middle .mobile-only {
//             order: 3;
//             flex: 0 0 100% !important;
//             width: 100% !important;
//             margin: 8px 0 0 0 !important;
//             padding: 0 !important;
//           }

//           .header-middle .header-right { display: none !important; }
//           .header-middle .logo img { max-height: 38px !important; width: auto !important; }

//           /* Mobile Bottom Nav */
//           .mobile-bottom-nav {
//             display: flex; position: fixed; bottom: 0; left: 0; right: 0;
//             background: white; border-top: 1px solid #e5e7eb; z-index: 1000;
//             padding: 8px 0 max(8px, env(safe-area-inset-bottom));
//             box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
//           }
//           .mobile-bottom-nav__item {
//             flex: 1; display: flex; flex-direction: column; align-items: center;
//             justify-content: center; text-decoration: none; color: #6b7280;
//             padding: 4px 8px; position: relative; transition: color 0.2s;
//             background: none; border: none; cursor: pointer;
//           }
//           .mobile-bottom-nav__item.active { color: #df4928; }
//           .mobile-bottom-nav__icon { font-size: 24px; margin-bottom: 2px; }
//           .mobile-bottom-nav__label { font-size: 11px; font-weight: 500; }

//           /* Mobile drawer */
//           .mobile-menu-drawer {
//             position: fixed; top: 0; left: -100%; width: 80%; max-width: 320px;
//             height: 100vh; background: white; z-index: 9999;
//             transition: left 0.3s ease; overflow-y: auto;
//             box-shadow: 2px 0 10px rgba(0,0,0,0.1);
//           }
//           .mobile-menu-drawer.active { left: 0; }
//           .mobile-menu-overlay {
//             position: fixed; top: 0; left: 0; right: 0; bottom: 0;
//             background: rgba(0,0,0,0.5); z-index: 9998;
//             opacity: 0; visibility: hidden; transition: all 0.3s ease;
//           }
//           .mobile-menu-overlay.active { opacity: 1; visibility: visible; }

//           /* Category modal */
//           .category-modal {
//             position: fixed; top: 0; left: 0; right: 0; bottom: 0;
//             background: white; z-index: 10000; transform: translateY(100%);
//             transition: transform 0.3s ease; display: flex; flex-direction: column;
//           }
//           .category-modal.active { transform: translateY(0); }
//           .category-modal__header {
//             padding: 16px; border-bottom: 1px solid #e5e7eb;
//             display: flex; align-items: center; justify-content: space-between;
//             position: sticky; top: 0; background: white; z-index: 1;
//           }
//           .category-modal__content { flex: 1; overflow-y: auto; padding: 16px; }
//           .category-item {
//             padding: 12px 16px; border-bottom: 1px solid #f3f4f6;
//             display: flex; align-items: center; justify-content: space-between;
//             text-decoration: none; color: #374151;
//           }
//           .category-item:active { background: #f9fafb; }

//           .header.bg-white { display: none; }
//           .category-strip { display: block; }
//           .mega-menu-wrapper { display: none; }
//         }

//         /* Hide Google Translate top bar */
// .goog-te-banner-frame,
// .goog-te-banner-frame.skiptranslate {
//   display: none !important;
// }

// /* Prevent the body from being pushed down by the bar */
// body {
//   top: 0 !important;
//   position: static !important;
// }

// /* Hide the "Translated by Google" floating element */
// #goog-gt-tt,
// .goog-gt-tt,
// .goog-tooltip,
// .goog-tooltip:hover {
//   display: none !important;
// }

// .goog-text-highlight {
//   background: none !important;
//   box-shadow: none !important;
// }
//       `}</style>

//       <div className="overlay" />
//       <div className={`side-overlay ${(menuActive || activeCategory) && "show"}`} />

//       {/* Mobile Menu Overlay */}
//       <div className={`mobile-menu-overlay ${menuActive ? "active" : ""}`} onClick={handleMenuToggle} />

//       {/* ── Mobile Menu Drawer ── */}
//       <div className={`mobile-menu-drawer mobile-only ${menuActive ? "active" : ""}`}>
//         <div style={{ padding: "16px", borderBottom: "1px solid #e5e7eb" }}>
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
//             <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>Menu</h3>
//             <button onClick={handleMenuToggle} style={{ background: "none", border: "none", fontSize: "24px", cursor: "pointer", padding: "4px" }}>
//               <i className="ph ph-x" />
//             </button>
//           </div>
//           <Link to={localStorage.getItem("authToken") ? "/user" : "/account"} style={{ textDecoration: "none" }}>
//             <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "12px", background: "#f9fafb", borderRadius: "8px" }}>
//               <div style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#df4928", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px" }}>
//                 <i className="ph ph-user" />
//               </div>
//               <div>
//                 <div style={{ fontWeight: "600", color: "#111" }}>My Account</div>
//                 <div style={{ fontSize: "12px", color: "#6b7280" }}>View profile</div>
//               </div>
//             </div>
//           </Link>
//         </div>

//         <div style={{ padding: "8px 0" }}>
//           {[
//             { to: "/", icon: "ph ph-house", label: "Home" },
//             { to: "/shop", icon: "ph ph-shopping-bag", label: "All Products" },
//             { to: "/wishlist", icon: "ph ph-heart", label: "Wishlist" },
//             { to: "/cart-one", icon: "ph ph-shopping-cart", label: "Cart" },
//           ].map(({ to, icon, label }) => (
//             <Link key={to} to={to} onClick={handleMenuToggle} style={{ display: "block", padding: "12px 16px", textDecoration: "none", color: "#374151", borderBottom: "1px solid #f3f4f6" }}>
//               <i className={icon} style={{ marginRight: "12px", fontSize: "18px" }} />
//               {label}
//             </Link>
//           ))}
//         </div>

//         <div style={{ padding: "16px", borderTop: "1px solid #e5e7eb" }}>
//           {/* Language selector in drawer */}
//           <div style={{ marginBottom: "16px" }}>
//             <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "8px" }}>Language</div>
//             <div id="gt-widget-mobile"></div>
//           </div>

//           <div style={{ marginBottom: "12px" }}>
//             <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "8px" }}>Currency</div>
//             <select
//               value={selectedCurrency}
//               onChange={(e) => handleCurrencyChange(e.target.value)}
//               style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #e5e7eb" }}
//             >
//               <option value="INR">INR - Indian Rupee</option>
//               <option value="USD">USD - US Dollar</option>
//               <option value="EUR">EUR - Euro</option>
//               <option value="AED">AED - Dirham</option>
//             </select>
//           </div>

//           <Link to="/become-seller" onClick={handleMenuToggle} style={{ display: "block", padding: "12px", background: "#df4928", color: "white", textAlign: "center", borderRadius: "6px", textDecoration: "none", marginTop: "8px" }}>
//             Become A Seller
//           </Link>
//           <Link to="https://tawk.to/chat/692acad3d7e07b1987ebcec7/1jb7igj0b" onClick={handleMenuToggle} style={{ display: "block", padding: "12px", background: "#df4928", color: "white", textAlign: "center", borderRadius: "6px", textDecoration: "none", marginTop: "12px" }}>
//             Help Center - Live Chat
//           </Link>
//         </div>
//       </div>

//       {/* Category Modal (mobile) */}
//       <div className={`category-modal mobile-only ${activeCategory ? "active" : ""}`}>
//         <div className="category-modal__header">
//           <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>All Categories</h3>
//           <button onClick={handleCategoryToggle} style={{ background: "none", border: "none", fontSize: "24px", cursor: "pointer", padding: "4px" }}>
//             <i className="ph ph-x" />
//           </button>
//         </div>
//         <div className="category-modal__content">
//           {categories.map((cat) => (
//             <Link key={cat._id} to={`/product-list-one?category=${cat._id}`} className="category-item" onClick={handleCategoryToggle}>
//               <span>{cat.name}</span>
//               <i className="ph ph-caret-right" />
//             </Link>
//           ))}
//         </div>
//       </div>

//       {/* Search Box */}
//       <form action="#" className={`search-box ${activeSearch && "active"}`}>
//         <button onClick={handleSearchToggle} type="button" className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1">
//           <i className="ph ph-x" />
//         </button>
//         <div className="container">
//           <div className="position-relative">
//             <input type="text" className="form-control py-16 px-24 text-xl rounded-pill pe-64" placeholder="Search for a product or brand" />
//             <button type="submit" className="w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8">
//               <i className="ph ph-magnifying-glass" />
//             </button>
//           </div>
//         </div>
//       </form>

//       {/* ── Top Header Bar (desktop) ── */}
//       <div className="header-top bg-main-600 flex-between desktop-only">
//         <div className="container container-lg">
//           <div className="flex-between flex-wrap gap-8">
//             <ul className="flex-align flex-wrap d-none d-md-flex">
//               <li className="border-right-item"><Link to="/become-seller" className="text-white text-sm hover-text-decoration-underline">Become A Seller</Link></li>
//               <li className="border-right-item"><Link to="/about-us" className="text-white text-sm hover-text-decoration-underline">About us</Link></li>
//               <li className="border-right-item"><Link to="/privacy-policy" className="text-white text-sm hover-text-decoration-underline">Privacy Policy</Link></li>
//             </ul>
//             <ul className="header-top__right flex-align flex-wrap">
//               <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
//                 <Link to="#" className="text-white text-sm py-8">Help Center</Link>
//                 <ul className="on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
//                   <li className="nav-submenu__item">
//                     <Link to="https://tawk.to/chat/692acad3d7e07b1987ebcec7/1jb7igj0b" className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0">
//                       <span className="text-sm d-flex"><i className="ph ph-chat-circle-dots" /></span>
//                       Live Chat
//                     </Link>
//                   </li>
//                 </ul>
//               </li>
//               <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
//                 <Link to="#" className="selected-text text-white text-sm py-8">{selectedCurrency}</Link>
//                 <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
//                   {[
//                     { code: "INR", flag: "IN" },
//                     { code: "USD", flag: "US" },
//                     { code: "EUR", flag: "FR" },
//                     { code: "AED", flag: "AE" },
//                   ].map(({ code, flag }) => (
//                     <li key={code}>
//                       <Link to="#" className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0" onClick={() => handleCurrencyChange(code)}>
//                         <img src={`https://flagsapi.com/${flag}/flat/64.png`} alt={code} className="w-16 h-12 rounded-4 border border-gray-100" />
//                         {code}
//                       </Link>
//                     </li>
//                   ))}
//                 </ul>
//               </li>
//               <li className="border-right-item">
//                 <Link to={localStorage.getItem("authToken") ? "/user" : "/account"} className="text-white text-sm py-8 flex-align gap-6">
//                   <span className="icon text-md d-flex"><i className="ph ph-user-circle" /></span>
//                   <span className="hover-text-decoration-underline">My Account</span>
//                 </Link>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>

//       {/* ── Middle Header ── */}
//       <header className={`header-middle bg-color-one border-gray-100 ${scroll && "fixed-header-middle"}`}>
//         <div className="container container-lg">
//           <nav className="header-inner flex-between">

//             {/* Logo — always first/left */}
//             <div className="logo">
//               <Link to="/" className="link">
//                 <img src="/assets/images/logo/logo.png" alt="Logo" />
//               </Link>
//             </div>

//             {/* Google Translate — desktop only, inline after logo */}
//             <div id="gt-widget" style={{ marginLeft: "16px", flexShrink: 0 }}></div>

//             {/* Search — desktop */}
//             <div className="desktop-only" style={{ flex: 1, marginLeft: "20px" }}>
//               <LiveSearch />
//             </div>

//             {/* Search — mobile (full width row 2) */}
//             <div className="mobile-only" style={{ flex: 1, marginLeft: "12px" }}>
//               <LiveSearch />
//             </div>

//             {/* Location — desktop only */}
//             <form action="#" className="flex-align flex-wrap form-location-wrapper desktop-only px-40">
//               <div className="location-box bg-white flex-align gap-8 py-6 px-16 rounded-pill border border-gray-100 ms-10">
//                 <span className="text-gray-900 text-xl d-xs-flex d-none"><i className="ph ph-map-pin" /></span>
//                 <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flex: 1 }}>
//                   <div className="text-gray-900 fw-medium" title={location.display} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "250px" }}>
//                     {location.display}
//                   </div>
//                 </div>
//                 <div style={{ position: "relative", marginTop: 0, marginRight: -6, width: "180px" }}>
//                   <input
//                     type="text" placeholder="Search city or place..." value={search}
//                     onChange={(e) => setSearch(e.target.value)} className="form-control"
//                     style={{ borderRadius: 20, padding: "6px 10px", fontSize: 13 }}
//                   />
//                   {loading && <div className="text-muted small mt-1">Searching…</div>}
//                   {suggestions.length > 0 && (
//                     <ul style={{ position: "absolute", zIndex: 1000, background: "white", border: "1px solid #ddd", borderRadius: 8, width: "100%", maxHeight: 200, overflowY: "auto", marginTop: 4, listStyle: "none", padding: 0 }}>
//                       {suggestions.map((s) => (
//                         <li key={s.id} onClick={() => handleSelectSuggestion(s)} style={{ padding: "8px 10px", cursor: "pointer" }}>
//                           <div style={{ fontSize: 13, color: "#111", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{s.display}</div>
//                           <div style={{ fontSize: 11, color: "#666" }}>{[s.city, s.state, s.country].filter(Boolean).join(", ")}</div>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>
//               </div>
//             </form>

//             {/* Wishlist + Cart — desktop only */}
//             <div className="header-right flex-align d-lg-block d-none">
//               <div className="flex-align flex-wrap gap-12">
//                 <Link to="/wishlist" className="flex-align gap-4 item-hover">
//                   <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
//                     <i className="ph ph-heart" />
//                   </span>
//                 </Link>
//                 <Link to="/cart-one" className="flex-align gap-4 item-hover position-relative">
//                   <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
//                     <i className="ph ph-shopping-cart-simple" />
//                     {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
//                   </span>
//                 </Link>
//               </div>
//             </div>
//           </nav>
//         </div>
//       </header>

//       {/* ── Desktop Nav Header ── */}
//       <header className="header bg-white border-bottom border-gray-100 desktop-only">
//         <div className="container container-lg">
//           <nav className="header-inner d-flex justify-content-between gap-8">
//             <div className="flex-align menu-category-wrapper">
//               <div className="mega-menu-wrapper" onMouseEnter={handleMegaMouseEnter} onMouseLeave={handleMegaMouseLeave} ref={megaMenuRef}>
//                 <button type="button" className="mega-menu-trigger">
//                   <span style={{ fontSize: "18px", display: "flex" }}><i className="ph ph-dots-nine" /></span>
//                   All Categories
//                   <span style={{ fontSize: "14px", display: "flex" }}><i className="ph ph-caret-down" /></span>
//                 </button>
//                 <div className={`mega-menu-panel ${megaMenuOpen ? "open" : ""}`}>
//                   <div className="mega-menu-left">
//                     {categories.map((cat) => (
//                       <div key={cat._id} className={`mega-menu-left-item ${megaHoveredCat?._id === cat._id ? "active" : ""}`} onMouseEnter={() => handleMegaCatHover(cat)}>
//                         <span>{cat.name}</span>
//                         <i className="ph ph-caret-right" style={{ fontSize: "12px", opacity: 0.5 }} />
//                       </div>
//                     ))}
//                   </div>
//                   <div className="mega-menu-right">
//                     {megaHoveredCat && (
//                       <>
//                         <h6>{megaHoveredCat.name}</h6>
//                         {subcategories[megaHoveredCat._id]?.length > 0 ? (
//                           <>
//                             <div className="mega-sub-grid">
//                               {subcategories[megaHoveredCat._id].map((sub) => (
//                                 <Link key={sub._id} to={`/product-list-one?category=${megaHoveredCat._id}&subcategory=${sub._id}`} className="mega-sub-link" onClick={() => setMegaMenuOpen(false)}>
//                                   <i className="ph ph-tag" style={{ marginRight: "6px", fontSize: "11px", opacity: 0.5 }} />
//                                   {sub.name}
//                                 </Link>
//                               ))}
//                             </div>
//                             <Link to={`/product-list-one?category=${megaHoveredCat._id}`} className="mega-view-all" onClick={() => setMegaMenuOpen(false)}>
//                               View all in {megaHoveredCat.name} →
//                             </Link>
//                           </>
//                         ) : (
//                           <div style={{ fontSize: "13px", color: "#9ca3af" }}>Loading subcategories…</div>
//                         )}
//                       </>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className="header-menu d-lg-block d-none">
//                 <ul className="nav-menu flex-align">
//                   <li className="nav-menu__item">
//                     <NavLink to="/" className={(n) => n.isActive ? "nav-menu__link activePage" : "nav-menu__link"}>Home</NavLink>
//                   </li>
//                   <li className="nav-menu__item">
//                     <NavLink to="/shop" className={(n) => n.isActive ? "nav-menu__link activePage" : "nav-menu__link"}>All Products</NavLink>
//                   </li>
//                 </ul>
//               </div>
//             </div>

//             <div className="header-right flex-align">
//               <Link to="tel:+919993553538" className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none">
//                 <div className="d-flex text-32"><i className="ph ph-phone-call" /></div>
//                 +91 9993553538
//               </Link>
//             </div>
//           </nav>
//         </div>
//       </header>

//       {/* ── Category Strip ── */}
//       <div className="category-strip">
//         <InfiniteStripScroller categories={categories} />
//       </div>

//       {/* ── Mobile Bottom Navigation ── */}
//       <nav className="mobile-bottom-nav">
//         <button onClick={handleMenuToggle} className="mobile-bottom-nav__item">
//           <i className="ph-fill ph-list mobile-bottom-nav__icon" />
//           <span className="mobile-bottom-nav__label">Menu</span>
//         </button>
//         <NavLink to="/shop" className={({ isActive }) => isActive ? "mobile-bottom-nav__item active" : "mobile-bottom-nav__item"}>
//           <i className="ph-fill ph-shopping-bag mobile-bottom-nav__icon" />
//           <span className="mobile-bottom-nav__label">Products</span>
//         </NavLink>
//         <NavLink to="/" className={({ isActive }) => isActive ? "mobile-bottom-nav__item active" : "mobile-bottom-nav__item"}>
//           <i className="ph-fill ph-house mobile-bottom-nav__icon" />
//           <span className="mobile-bottom-nav__label">Home</span>
//         </NavLink>
//         <button onClick={handleCategoryToggle} className="mobile-bottom-nav__item">
//           <i className="ph-fill ph-squares-four mobile-bottom-nav__icon" />
//           <span className="mobile-bottom-nav__label">Category</span>
//         </button>
//         <NavLink to="/cart-one" className={({ isActive }) => isActive ? "mobile-bottom-nav__item active" : "mobile-bottom-nav__item"}>
//           <i className="ph-fill ph-shopping-cart mobile-bottom-nav__icon" />
//           <span className="mobile-bottom-nav__label">Cart</span>
//         </NavLink>
//       </nav>
//     </>
//   );
// };

// export default HeaderOne;



import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import LiveSearch from "./LiveSearch/LiveSearch";

const NOMINATIM_BASE = "https://nominatim.openstreetmap.org";

/* ── Netflix-style Infinite Scrolling Strip ── */
const InfiniteStripScroller = ({ categories }) => {
  const trackRef = useRef(null);
  const animFrameRef = useRef(null);
  const posRef = useRef(0);
  const pausedRef = useRef(true);
  const halfWidthRef = useRef(0);
  const startDelayRef = useRef(null);

  const items = [
    { id: "__deals__", name: "Deals", to: "/shop", featured: true, icon: "ph ph-fire" },
    ...categories.map((c) => ({ id: c._id, name: c.name, to: `/product-list-one?category=${c._id}` })),
    { id: "__seller__", name: "Sell with us", to: "/become-seller", icon: "ph ph-storefront" },
  ];

  const allItems = [...items, ...items];

  useEffect(() => {
    if (!trackRef.current || items.length === 0) return;
    const measure = () => {
      const fullWidth = trackRef.current?.scrollWidth || 0;
      halfWidthRef.current = fullWidth / 2;
    };
    const frame = requestAnimationFrame(measure);
    startDelayRef.current = setTimeout(() => { pausedRef.current = false; }, 1000);
    const SPEED = 0.6;
    const tick = () => {
      if (!pausedRef.current && trackRef.current && halfWidthRef.current > 0) {
        posRef.current += SPEED;
        if (posRef.current >= halfWidthRef.current) posRef.current = 0;
        trackRef.current.style.transform = `translateX(-${posRef.current}px)`;
      }
      animFrameRef.current = requestAnimationFrame(tick);
    };
    animFrameRef.current = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(frame);
      cancelAnimationFrame(animFrameRef.current);
      clearTimeout(startDelayRef.current);
    };
  }, [categories]);

  const handleMouseEnter = () => { pausedRef.current = true; };
  const handleMouseLeave = () => { pausedRef.current = false; };

  if (categories.length === 0) return null;

  return (
    <div style={{ overflow: "hidden", width: "100%" }} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div ref={trackRef} className="category-strip__track">
        {allItems.map((item, idx) => (
          <React.Fragment key={`${item.id}-${idx}`}>
            <Link to={item.to} className={`category-strip__link${item.featured ? " strip-featured" : ""}`}>
              {item.icon && <i className={item.icon} style={{ fontSize: "13px" }} />}
              {item.name}
            </Link>
            <span className="category-strip__divider">·</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

const HeaderOne = () => {
  const [scroll, setScroll] = useState(false);
  const [location, setLocation] = useState({ display: "Detecting...", city: "", state: "", country: "" });
  const [search, setSearch] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const abortRef = useRef(null);
  const debounceRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScroll(window.pageYOffset > 150);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const fetchCurrentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          const { latitude, longitude } = pos.coords;
          try {
            const res = await fetch(`${NOMINATIM_BASE}/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`);
            const data = await res.json();
            const addr = data.address || {};
            const city = addr.city || addr.town || addr.village || addr.county || "";
            const state = addr.state || "";
            const country = addr.country || "";
            setLocation({ display: [city, state, country].filter(Boolean).join(", "), city, state, country });
          } catch {
            setLocation({ display: "Unable to fetch location", city: "", state: "", country: "" });
          }
        },
        () => setLocation({ display: "Location not available", city: "", state: "", country: "" }),
      );
    } else {
      setLocation({ display: "Geolocation not supported", city: "", state: "", country: "" });
    }
  };

  useEffect(() => { fetchCurrentLocation(); }, []);

  useEffect(() => {
    if (!search || search.length < 2) { setSuggestions([]); return; }
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      if (abortRef.current) abortRef.current.abort();
      abortRef.current = new AbortController();
      try {
        const res = await fetch(
          `${NOMINATIM_BASE}/search?q=${encodeURIComponent(search)}&format=json&addressdetails=1&limit=5`,
          { signal: abortRef.current.signal },
        );
        const results = await res.json();
        const sug = results.map((r) => {
          const addr = r.address || {};
          const city = addr.city || addr.town || addr.village || addr.county || "";
          const state = addr.state || "";
          const country = addr.country || "";
          return { id: r.place_id, display: r.display_name, city, state, country };
        });
        setSuggestions(sug);
      } catch { setSuggestions([]); }
      finally { setLoading(false); }
    }, 400);
    return () => clearTimeout(debounceRef.current);
  }, [search]);

  const handleSelectSuggestion = (s) => {
    setLocation({ display: [s.city, s.state, s.country].filter(Boolean).join(", "), city: s.city, state: s.state, country: s.country });
    setSearch("");
    setSuggestions([]);
  };

  const [selectedCurrency, setSelectedCurrency] = useState(localStorage.getItem("selectedCurrency") || "INR");

  useEffect(() => {
    const saved = localStorage.getItem("selectedCurrency");
    if (!saved) {
      localStorage.setItem("selectedCurrency", "INR");
      setSelectedCurrency("INR");
      window.location.reload();
    }
  }, []);

  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
    localStorage.setItem("selectedCurrency", currency);
    window.location.reload();
  };

  const [menuActive, setMenuActive] = useState(false);
  const handleMenuToggle = () => setMenuActive(!menuActive);

  const [activeSearch, setActiveSearch] = useState(false);
  const handleSearchToggle = () => setActiveSearch(!activeSearch);

  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState({});
  const [activeCategory, setActiveCategory] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  // ── Mobile category drill-down state ──
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const [mobileSelectedCat, setMobileSelectedCat] = useState(null); // null = show category list, object = show subcategory list
  const [mobileSubcategories, setMobileSubcategories] = useState({});
  const [mobileSubLoading, setMobileSubLoading] = useState(false);

  const [megaMenuOpen, setMegaMenuOpen] = useState(false);
  const [megaHoveredCat, setMegaHoveredCat] = useState(null);
  const megaMenuRef = useRef(null);
  const megaLeaveTimer = useRef(null);

  const handleMegaMouseEnter = () => {
    if (megaLeaveTimer.current) clearTimeout(megaLeaveTimer.current);
    setMegaMenuOpen(true);
    if (categories.length > 0 && !megaHoveredCat) setMegaHoveredCat(categories[0]);
  };

  const handleMegaMouseLeave = () => {
    megaLeaveTimer.current = setTimeout(() => {
      setMegaMenuOpen(false);
      setMegaHoveredCat(null);
    }, 150);
  };

  const handleMegaCatHover = async (cat) => {
    setMegaHoveredCat(cat);
    if (subcategories[cat._id]) return;
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/subcategory/category/${cat._id}`);
      if (response.data.success) setSubcategories((prev) => ({ ...prev, [cat._id]: response.data.data }));
    } catch (error) { console.error("Error fetching subcategories:", error); }
  };

  const handleCategoryToggle = () => {
    setMobileCatOpen(!mobileCatOpen);
    setMobileSelectedCat(null); // always reset to category list on open
  };

  // ── Fetch subcategories for selected mobile category ──
  const handleMobileCatSelect = async (cat) => {
    setMobileSelectedCat(cat);
    if (mobileSubcategories[cat._id]) return; // already loaded
    setMobileSubLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/subcategory/category/${cat._id}`);
      if (response.data.success) {
        setMobileSubcategories((prev) => ({ ...prev, [cat._id]: response.data.data }));
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    } finally {
      setMobileSubLoading(false);
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/category/all`);
        setCategories(res.data.data);
        if (res.data.data.length > 0) setMegaHoveredCat(res.data.data[0]);
      } catch (err) { console.error("Error fetching categories:", err); }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const cartRaw = localStorage.getItem("cart");
    const cart = cartRaw ? JSON.parse(cartRaw) : [];
    setCartCount(cart.length);
  }, []);

  useEffect(() => {
    const isMobile = window.innerWidth < 992;
    const containerId = isMobile ? "gt-widget-mobile" : "gt-widget";

    const initTranslate = () => {
      try {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,hi,mr,ur,ar,bn,ta,te,kn,ml,gu,pa,or,as,fr,de,es,it,pt,ru,zh-CN,ja,ko,tr,nl,pl,sv,th,vi,id",
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false,
          },
          containerId
        );
        setTimeout(() => {
          document.querySelectorAll(".goog-logo-link").forEach((el) => el.remove());
          document.querySelectorAll(".goog-te-gadget").forEach((gadget) => {
            gadget.childNodes.forEach((node) => {
              if (node.nodeType === Node.TEXT_NODE) node.remove();
              if (node.nodeName === "SPAN" && node.querySelector?.("a")) node.remove();
            });
          });
        }, 800);
      } catch (e) {
        console.warn("GT init failed", e);
      }
    };

    const waitForContainer = (callback) => {
      const el = document.getElementById(containerId);
      if (el) { callback(); return; }
      const interval = setInterval(() => {
        if (document.getElementById(containerId)) {
          clearInterval(interval);
          callback();
        }
      }, 50);
      setTimeout(() => clearInterval(interval), 5000);
    };

    const reinjectIfNeeded = () => {
      const containerId2 = (window.innerWidth < 992) ? "gt-widget-mobile" : "gt-widget";
      const container = document.getElementById(containerId2);
      if (container && !container.querySelector(".goog-te-gadget")) {
        try {
          new window.google.translate.TranslateElement(
            {
              pageLanguage: "en",
              includedLanguages: "en,hi,mr,ur,ar,bn,ta,te,kn,ml,gu,pa,or,as,fr,de,es,it,pt,ru,zh-CN,ja,ko,tr,nl,pl,sv,th,vi,id",
              layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
              autoDisplay: false,
            },
            containerId2
          );
        } catch (e) {}
      }
    };

    if (window.google?.translate?.TranslateElement) {
      waitForContainer(reinjectIfNeeded);
    } else {
      window.googleTranslateElementInit = () => {
        waitForContainer(initTranslate);
      };
      if (!document.getElementById("gt-script")) {
        const s = document.createElement("script");
        s.id = "gt-script";
        s.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        s.async = true;
        document.body.appendChild(s);
      }
    }
  }, []);

  return (
    <>
      <style>{`
        /* ── Mega Menu ── */
        .mega-menu-wrapper { position: relative; display: inline-block; }
        .mega-menu-trigger {
          display: flex; align-items: center; gap: 8px; padding: 10px 18px;
          background: #df4928; color: white; font-weight: 600; font-size: 14px;
          border: none; cursor: pointer; border-radius: 4px; white-space: nowrap;
          transition: background 0.2s; height: 100%;
        }
        .mega-menu-trigger:hover { background: #c73e20; }
        .mega-menu-panel {
          display: none; position: absolute; top: calc(100% + 4px); left: 0;
          width: 680px; background: white; border: 1px solid #e5e7eb;
          border-radius: 8px; box-shadow: 0 8px 32px rgba(0,0,0,0.13);
          z-index: 2000; overflow: hidden;
        }
        .mega-menu-panel.open { display: flex; }
        .mega-menu-left {
          width: 220px; min-width: 220px; background: #f9fafb;
          border-right: 1px solid #e5e7eb; overflow-y: auto; max-height: 420px;
        }
        .mega-menu-left-item {
          display: flex; align-items: center; justify-content: space-between;
          padding: 11px 16px; font-size: 14px; color: #374151; cursor: pointer;
          transition: background 0.15s, color 0.15s; text-decoration: none;
          border-bottom: 1px solid #f3f4f6; font-weight: 500;
        }
        .mega-menu-left-item:hover, .mega-menu-left-item.active { background: #fff7f5; color: #df4928; }
        .mega-menu-left-item.active { border-right: 3px solid #df4928; }
        .mega-menu-right { flex: 1; padding: 16px 20px; overflow-y: auto; max-height: 420px; }
        .mega-menu-right h6 {
          font-size: 13px; font-weight: 700; color: #df4928; text-transform: uppercase;
          letter-spacing: 0.5px; margin: 0 0 12px; padding-bottom: 8px; border-bottom: 1px solid #f3f4f6;
        }
        .mega-sub-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4px 12px; }
        .mega-sub-link {
          display: block; padding: 7px 10px; font-size: 13px; color: #374151;
          text-decoration: none; border-radius: 6px; transition: background 0.15s, color 0.15s;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }
        .mega-sub-link:hover { background: #fff3f0; color: #df4928; }
        .mega-view-all {
          display: inline-block; margin-top: 12px; font-size: 12px; color: #df4928;
          text-decoration: none; font-weight: 600; border: 1px solid #df4928;
          border-radius: 20px; padding: 4px 14px; transition: background 0.15s, color 0.15s;
        }
        .mega-view-all:hover { background: #df4928; color: white; }

        /* ── Category Strip ── */
        .category-strip { background: #1a1a2e; overflow: hidden; white-space: nowrap; position: relative; }
        .category-strip__track { display: flex; align-items: center; min-height: 38px; width: max-content; will-change: transform; }
        .category-strip__link {
          display: inline-flex; align-items: center; gap: 5px; padding: 8px 18px;
          font-size: 13px; color: #d1d5db; text-decoration: none; white-space: nowrap;
          transition: color 0.15s, background 0.15s; border-radius: 4px; font-weight: 500; flex-shrink: 0;
        }
        .category-strip__link:hover { color: white; background: rgba(255,255,255,0.1); }
        .category-strip__link.strip-featured { color: #fbbf24; font-weight: 600; }
        .category-strip__link.strip-featured:hover { color: #f59e0b; background: rgba(251,191,36,0.12); }
        .category-strip__divider { color: rgba(255,255,255,0.15); font-size: 16px; padding: 0 2px; user-select: none; flex-shrink: 0; }

        /* ── Google Translate Widget ── */
        #gt-widget { display: flex; align-items: center; flex-shrink: 0; }
        #gt-widget .goog-te-gadget-simple {
          border: 1px solid #e5e7eb !important; border-radius: 20px !important;
          padding: 5px 12px !important; background: white !important;
          font-size: 13px !important; white-space: nowrap !important; cursor: pointer !important;
        }
        #gt-widget img, .goog-logo-link, .goog-te-gadget > a, .goog-te-gadget > span > a { display: none !important; }
        .goog-te-gadget { font-size: 13px !important; line-height: normal !important; }
        .goog-te-gadget-simple a.goog-te-menu-value {
          color: #374151 !important; text-decoration: none !important;
          font-size: 13px !important; display: flex !important; align-items: center !important; gap: 4px !important;
        }
        .goog-te-menu-value span:last-child { display: none !important; }

        #gt-widget-mobile .goog-te-gadget-simple {
          border: 1px solid #e5e7eb !important; border-radius: 8px !important;
          padding: 8px 12px !important; background: white !important;
          font-size: 13px !important; width: 100% !important; display: flex !important; cursor: pointer !important;
        }
        #gt-widget-mobile img, #gt-widget-mobile .goog-logo-link { display: none !important; }
        #gt-widget-mobile .goog-te-gadget-simple a.goog-te-menu-value {
          color: #374151 !important; text-decoration: none !important;
          font-size: 13px !important; width: 100% !important;
        }

        /* ── Fixed header on scroll ── */
        .fixed-header-middle { position: fixed; top: 0; left: 0; right: 0; z-index: 1100; animation: slideDown 0.3s ease; }

        /* ── Cart badge ── */
        .cart-badge {
          position: absolute; top: -6px; right: -10px;
          background-color: #ff3d00; color: #fff; font-size: 11px; font-weight: 600;
          height: 18px; min-width: 18px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center; padding: 0 4px;
        }

        @media (min-width: 992px) { .mobile-only { display: none !important; } }
        @media (max-width: 991px) { .desktop-only { display: none !important; } }

        /* ── Mobile Bottom Nav ── */
        .mobile-bottom-nav { display: none; }

        @media (max-width: 991px) {
          body { padding-bottom: 60px; }
          .header-middle { padding: 8px 0; }
          .header-middle .header-inner { flex-wrap: wrap !important; align-items: center !important; gap: 0 !important; }
          .header-middle .logo { order: 1; flex: 0 0 auto; }
          #gt-widget { order: 2; margin-left: auto; flex-shrink: 0; display: none !important; }
          .header-middle .mobile-only { order: 3; flex: 0 0 100% !important; width: 100% !important; margin: 8px 0 0 0 !important; padding: 0 !important; }
          .header-middle .header-right { display: none !important; }
          .header-middle .logo img { max-height: 38px !important; width: auto !important; }

          .mobile-bottom-nav {
            display: flex; position: fixed; bottom: 0; left: 0; right: 0;
            background: white; border-top: 1px solid #e5e7eb; z-index: 1000;
            padding: 8px 0 max(8px, env(safe-area-inset-bottom));
            box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
          }
          .mobile-bottom-nav__item {
            flex: 1; display: flex; flex-direction: column; align-items: center;
            justify-content: center; text-decoration: none; color: #6b7280;
            padding: 4px 8px; position: relative; transition: color 0.2s;
            background: none; border: none; cursor: pointer;
          }
          .mobile-bottom-nav__item.active { color: #df4928; }
          .mobile-bottom-nav__icon { font-size: 24px; margin-bottom: 2px; }
          .mobile-bottom-nav__label { font-size: 11px; font-weight: 500; }

          /* Mobile drawer */
          .mobile-menu-drawer {
            position: fixed; top: 0; left: -100%; width: 80%; max-width: 320px;
            height: 100vh; background: white; z-index: 9999;
            transition: left 0.3s ease; overflow-y: auto;
            box-shadow: 2px 0 10px rgba(0,0,0,0.1);
          }
          .mobile-menu-drawer.active { left: 0; }
          .mobile-menu-overlay {
            position: fixed; top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0,0,0,0.5); z-index: 9998;
            opacity: 0; visibility: hidden; transition: all 0.3s ease;
          }
          .mobile-menu-overlay.active { opacity: 1; visibility: visible; }

          .header.bg-white { display: none; }
          .category-strip { display: block; }
          .mega-menu-wrapper { display: none; }
        }

        /* ── Mobile Category Modal (full-screen) ── */
        .mobile-cat-modal {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: #f9fafb; z-index: 10000;
          transform: translateY(100%);
          transition: transform 0.3s cubic-bezier(0.4,0,0.2,1);
          display: flex; flex-direction: column;
          overflow: hidden;
        }
        .mobile-cat-modal.active { transform: translateY(0); }

        .mobile-cat-modal__header {
          display: flex; align-items: center; gap: 12px;
          padding: 14px 16px; background: white;
          border-bottom: 1px solid #e5e7eb;
          position: sticky; top: 0; z-index: 2;
          min-height: 56px;
        }
        .mobile-cat-modal__header h3 {
          margin: 0; font-size: 17px; font-weight: 700; color: #111; flex: 1;
        }
        .mobile-cat-modal__back {
          background: none; border: none; cursor: pointer;
          padding: 6px; font-size: 22px; color: #374151;
          display: flex; align-items: center; justify-content: center;
          border-radius: 6px; transition: background 0.15s;
        }
        .mobile-cat-modal__back:hover { background: #f3f4f6; }
        .mobile-cat-modal__close {
          background: none; border: none; cursor: pointer;
          padding: 6px; font-size: 22px; color: #374151;
          display: flex; align-items: center; justify-content: center;
          border-radius: 6px; transition: background 0.15s; margin-left: auto;
        }
        .mobile-cat-modal__close:hover { background: #f3f4f6; }

        /* Slide panels */
        .mobile-cat-panels {
          flex: 1; overflow: hidden; position: relative;
        }
        .mobile-cat-panel {
          position: absolute; top: 0; left: 0; right: 0; bottom: 0;
          overflow-y: auto; background: #f9fafb;
          transition: transform 0.28s cubic-bezier(0.4,0,0.2,1);
        }
        .mobile-cat-panel.panel-cat  { transform: translateX(0); }
        .mobile-cat-panel.panel-sub  { transform: translateX(100%); }
        .mobile-cat-panel.panel-cat.slide-left  { transform: translateX(-100%); }
        .mobile-cat-panel.panel-sub.slide-in    { transform: translateX(0); }

        .mobile-cat-item {
          display: flex; align-items: center; justify-content: space-between;
          padding: 14px 16px; background: white; margin: 0 0 1px 0;
          cursor: pointer; text-decoration: none; color: #111;
          border-bottom: 1px solid #f3f4f6; font-size: 15px; font-weight: 500;
          transition: background 0.15s;
          -webkit-tap-highlight-color: transparent;
        }
        .mobile-cat-item:active, .mobile-cat-item:hover { background: #fff7f5; color: #df4928; }
        .mobile-cat-item__icon { font-size: 18px; color: #9ca3af; flex-shrink: 0; }

        .mobile-sub-header {
          padding: 12px 16px; background: #fff7f5;
          border-bottom: 2px solid #df4928;
          font-size: 13px; color: #df4928; font-weight: 700;
          text-transform: uppercase; letter-spacing: 0.4px;
          display: flex; align-items: center; justify-content: space-between;
        }
        .mobile-sub-view-all {
          display: block; margin: 12px 16px; padding: 12px 16px;
          background: #df4928; color: white; text-align: center;
          border-radius: 8px; text-decoration: none; font-size: 14px; font-weight: 600;
        }
        .mobile-sub-item {
          display: flex; align-items: center; gap: 10px;
          padding: 13px 16px; background: white; margin: 0 0 1px 0;
          cursor: pointer; text-decoration: none; color: #374151;
          border-bottom: 1px solid #f3f4f6; font-size: 14px;
          transition: background 0.15s;
          -webkit-tap-highlight-color: transparent;
        }
        .mobile-sub-item:active, .mobile-sub-item:hover { background: #fff7f5; color: #df4928; }
        .mobile-sub-item i { font-size: 14px; color: #df4928; flex-shrink: 0; opacity: 0.7; }

        .mobile-sub-loading {
          display: flex; align-items: center; justify-content: center;
          padding: 40px 16px; gap: 10px; color: #9ca3af; font-size: 14px;
        }
        .mobile-sub-spinner {
          width: 20px; height: 20px; border: 2px solid #e5e7eb;
          border-top-color: #df4928; border-radius: 50%;
          animation: spinCat 0.7s linear infinite;
        }
        @keyframes spinCat { to { transform: rotate(360deg); } }

        /* Translate */
        .goog-te-banner-frame, .goog-te-banner-frame.skiptranslate { display: none !important; }
        body { top: 0 !important; position: static !important; }
        #goog-gt-tt, .goog-gt-tt, .goog-tooltip, .goog-tooltip:hover { display: none !important; }
        .goog-text-highlight { background: none !important; box-shadow: none !important; }
      `}</style>

      <div className="overlay" />
      <div className={`side-overlay ${(menuActive || activeCategory) && "show"}`} />

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${menuActive ? "active" : ""}`} onClick={handleMenuToggle} />

      {/* ── Mobile Menu Drawer ── */}
      <div className={`mobile-menu-drawer mobile-only ${menuActive ? "active" : ""}`}>
        <div style={{ padding: "16px", borderBottom: "1px solid #e5e7eb" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>Menu</h3>
            <button onClick={handleMenuToggle} style={{ background: "none", border: "none", fontSize: "24px", cursor: "pointer", padding: "4px" }}>
              <i className="ph ph-x" />
            </button>
          </div>
          <Link to={localStorage.getItem("authToken") ? "/user" : "/account"} style={{ textDecoration: "none" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "12px", background: "#f9fafb", borderRadius: "8px" }}>
              <div style={{ width: "40px", height: "40px", borderRadius: "50%", background: "#df4928", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px" }}>
                <i className="ph ph-user" />
              </div>
              <div>
                <div style={{ fontWeight: "600", color: "#111" }}>My Account</div>
                <div style={{ fontSize: "12px", color: "#6b7280" }}>View profile</div>
              </div>
            </div>
          </Link>
        </div>

        <div style={{ padding: "8px 0" }}>
          {[
            { to: "/", icon: "ph ph-house", label: "Home" },
            { to: "/shop", icon: "ph ph-shopping-bag", label: "All Products" },
            { to: "/wishlist", icon: "ph ph-heart", label: "Wishlist" },
            { to: "/cart-one", icon: "ph ph-shopping-cart", label: "Cart" },
          ].map(({ to, icon, label }) => (
            <Link key={to} to={to} onClick={handleMenuToggle} style={{ display: "block", padding: "12px 16px", textDecoration: "none", color: "#374151", borderBottom: "1px solid #f3f4f6" }}>
              <i className={icon} style={{ marginRight: "12px", fontSize: "18px" }} />
              {label}
            </Link>
          ))}
        </div>

        <div style={{ padding: "16px", borderTop: "1px solid #e5e7eb" }}>
          <div style={{ marginBottom: "16px" }}>
            <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "8px" }}>Language</div>
            <div id="gt-widget-mobile"></div>
          </div>
          <div style={{ marginBottom: "12px" }}>
            <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "8px" }}>Currency</div>
            <select
              value={selectedCurrency}
              onChange={(e) => handleCurrencyChange(e.target.value)}
              style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #e5e7eb" }}
            >
              <option value="INR">INR - Indian Rupee</option>
              <option value="USD">USD - US Dollar</option>
              <option value="EUR">EUR - Euro</option>
              <option value="AED">AED - Dirham</option>
              <option value="SAR">SAR - Riyal</option>
              <option value="QAR">QAR - Qatari Riyal</option>
              <option value="GBP">GBP - British Pound</option>
              <option value="CAD">CAD - Canadian dollar</option>
            </select>
          </div>
          <Link to="/become-seller" onClick={handleMenuToggle} style={{ display: "block", padding: "12px", background: "#df4928", color: "white", textAlign: "center", borderRadius: "6px", textDecoration: "none", marginTop: "8px" }}>
            Become A Seller
          </Link>
          <Link to="https://tawk.to/chat/692acad3d7e07b1987ebcec7/1jb7igj0b" onClick={handleMenuToggle} style={{ display: "block", padding: "12px", background: "#df4928", color: "white", textAlign: "center", borderRadius: "6px", textDecoration: "none", marginTop: "12px" }}>
            Help Center - Live Chat
          </Link>
        </div>
      </div>

      {/* ═══════════════════════════════════════════
          MOBILE CATEGORY MODAL — Two-panel drill-down
          ═══════════════════════════════════════════ */}
      <div className={`mobile-cat-modal mobile-only ${mobileCatOpen ? "active" : ""}`}>

        {/* Header — changes based on panel */}
        <div className="mobile-cat-modal__header">
          {mobileSelectedCat ? (
            <button
              className="mobile-cat-modal__back"
              onClick={() => setMobileSelectedCat(null)}
              aria-label="Back to categories"
            >
              <i className="ph ph-arrow-left" />
            </button>
          ) : null}
          <h3>{mobileSelectedCat ? mobileSelectedCat.name : "All Categories"}</h3>
          <button
            className="mobile-cat-modal__close"
            onClick={() => { setMobileCatOpen(false); setMobileSelectedCat(null); }}
            aria-label="Close"
          >
            <i className="ph ph-x" />
          </button>
        </div>

        {/* Sliding panels */}
        <div className="mobile-cat-panels">

          {/* Panel 1 — Category list */}
          <div className={`mobile-cat-panel panel-cat ${mobileSelectedCat ? "slide-left" : ""}`}>
            {/* View all products shortcut */}
            <Link
              to="/shop"
              className="mobile-cat-item"
              onClick={() => { setMobileCatOpen(false); setMobileSelectedCat(null); }}
            >
              <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <i className="ph ph-shopping-bag" style={{ fontSize: 18, color: "#df4928" }} />
                All Products
              </span>
              <i className="ph ph-arrow-right mobile-cat-item__icon" />
            </Link>

            {categories.map((cat) => (
              <div
                key={cat._id}
                className="mobile-cat-item"
                onClick={() => handleMobileCatSelect(cat)}
              >
                <span>{cat.name}</span>
                <i className="ph ph-caret-right mobile-cat-item__icon" />
              </div>
            ))}
          </div>

          {/* Panel 2 — Subcategory list */}
          <div className={`mobile-cat-panel panel-sub ${mobileSelectedCat ? "slide-in" : ""}`}>
            {mobileSelectedCat && (
              <>
                {/* View all in this category */}
                <Link
                  to={`/product-list-one?category=${mobileSelectedCat._id}`}
                  className="mobile-sub-view-all"
                  onClick={() => { setMobileCatOpen(false); setMobileSelectedCat(null); }}
                >
                  View All in {mobileSelectedCat.name}
                </Link>

                <div className="mobile-sub-header">
                  <span>Subcategories</span>
                  <span style={{ fontSize: 11, fontWeight: 400, color: "#9ca3af", textTransform: "none" }}>
                    {mobileSubcategories[mobileSelectedCat._id]?.length || 0} found
                  </span>
                </div>

                {mobileSubLoading ? (
                  <div className="mobile-sub-loading">
                    <div className="mobile-sub-spinner" />
                    Loading subcategories…
                  </div>
                ) : mobileSubcategories[mobileSelectedCat._id]?.length > 0 ? (
                  mobileSubcategories[mobileSelectedCat._id].map((sub) => (
                    <Link
                      key={sub._id}
                      to={`/product-list-one?category=${mobileSelectedCat._id}&subcategory=${sub._id}`}
                      className="mobile-sub-item"
                      onClick={() => { setMobileCatOpen(false); setMobileSelectedCat(null); }}
                    >
                      <i className="ph ph-tag" />
                      {sub.name}
                    </Link>
                  ))
                ) : (
                  <div style={{ padding: "24px 16px", textAlign: "center", color: "#9ca3af", fontSize: 14 }}>
                    No subcategories available
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Search Box */}
      <form action="#" className={`search-box ${activeSearch && "active"}`}>
        <button onClick={handleSearchToggle} type="button" className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1">
          <i className="ph ph-x" />
        </button>
        <div className="container">
          <div className="position-relative">
            <input type="text" className="form-control py-16 px-24 text-xl rounded-pill pe-64" placeholder="Search for a product or brand" />
            <button type="submit" className="w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8">
              <i className="ph ph-magnifying-glass" />
            </button>
          </div>
        </div>
      </form>

      {/* ── Top Header Bar (desktop) ── */}
      <div className="header-top bg-main-600 flex-between desktop-only">
        <div className="container container-lg">
          <div className="flex-between flex-wrap gap-8">
            <ul className="flex-align flex-wrap d-none d-md-flex">
              <li className="border-right-item"><Link to="/become-seller" className="text-white text-sm hover-text-decoration-underline">Become A Seller</Link></li>
              <li className="border-right-item"><Link to="/about-us" className="text-white text-sm hover-text-decoration-underline">About us</Link></li>
              <li className="border-right-item"><Link to="/privacy-policy" className="text-white text-sm hover-text-decoration-underline">Privacy Policy</Link></li>
            </ul>
            <ul className="header-top__right flex-align flex-wrap">
              <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                <Link to="#" className="text-white text-sm py-8">Help Center</Link>
                <ul className="on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                  <li className="nav-submenu__item">
                    <Link to="https://tawk.to/chat/692acad3d7e07b1987ebcec7/1jb7igj0b" className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0">
                      <span className="text-sm d-flex"><i className="ph ph-chat-circle-dots" /></span>
                      Live Chat
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                <Link to="#" className="selected-text text-white text-sm py-8">{selectedCurrency}</Link>
                <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                  {[
                    { code: "INR", flag: "IN" },
                    { code: "USD", flag: "US" },
                    { code: "EUR", flag: "FR" },
                    { code: "AED", flag: "AE" },
                    { code: "SAR", flag: "SA" },
                    { code: "QAR", flag: "QA" },
                    { code: "GBP", flag: "GB" },
                    { code: "CAD", flag: "CA" },
                  ].map(({ code, flag }) => (
                    <li key={code}>
                      <Link to="#" className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0" onClick={() => handleCurrencyChange(code)}>
                        <img src={`https://flagsapi.com/${flag}/flat/64.png`} alt={code} className="w-16 h-12 rounded-4 border border-gray-100" />
                        {code}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              <li className="border-right-item">
                <Link to={localStorage.getItem("authToken") ? "/user" : "/account"} className="text-white text-sm py-8 flex-align gap-6">
                  <span className="icon text-md d-flex"><i className="ph ph-user-circle" /></span>
                  <span className="hover-text-decoration-underline">My Account</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* ── Middle Header ── */}
      <header className={`header-middle bg-color-one border-gray-100 ${scroll && "fixed-header-middle"}`}>
        <div className="container container-lg">
          <nav className="header-inner flex-between">
            <div className="logo">
              <Link to="/" className="link">
                <img src="/assets/images/logo/logo.png" alt="Logo" />
              </Link>
            </div>
            <div id="gt-widget" style={{ marginLeft: "16px", flexShrink: 0 }}></div>
            <div className="desktop-only" style={{ flex: 1, marginLeft: "20px" }}>
              <LiveSearch />
            </div>
            <div className="mobile-only" style={{ flex: 1, marginLeft: "12px" }}>
              <LiveSearch />
            </div>
            <form action="#" className="flex-align flex-wrap form-location-wrapper desktop-only px-40">
              <div className="location-box bg-white flex-align gap-8 py-6 px-16 rounded-pill border border-gray-100 ms-10">
                <span className="text-gray-900 text-xl d-xs-flex d-none"><i className="ph ph-map-pin" /></span>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flex: 1 }}>
                  <div className="text-gray-900 fw-medium" title={location.display} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "250px" }}>
                    {location.display}
                  </div>
                </div>
                <div style={{ position: "relative", marginTop: 0, marginRight: -6, width: "180px" }}>
                  <input
                    type="text" placeholder="Search city or place..." value={search}
                    onChange={(e) => setSearch(e.target.value)} className="form-control"
                    style={{ borderRadius: 20, padding: "6px 10px", fontSize: 13 }}
                  />
                  {loading && <div className="text-muted small mt-1">Searching…</div>}
                  {suggestions.length > 0 && (
                    <ul style={{ position: "absolute", zIndex: 1000, background: "white", border: "1px solid #ddd", borderRadius: 8, width: "100%", maxHeight: 200, overflowY: "auto", marginTop: 4, listStyle: "none", padding: 0 }}>
                      {suggestions.map((s) => (
                        <li key={s.id} onClick={() => handleSelectSuggestion(s)} style={{ padding: "8px 10px", cursor: "pointer" }}>
                          <div style={{ fontSize: 13, color: "#111", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{s.display}</div>
                          <div style={{ fontSize: 11, color: "#666" }}>{[s.city, s.state, s.country].filter(Boolean).join(", ")}</div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </form>
            <div className="header-right flex-align d-lg-block d-none">
              <div className="flex-align flex-wrap gap-12">
                <Link to="/wishlist" className="flex-align gap-4 item-hover">
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-heart" />
                  </span>
                </Link>
                <Link to="/cart-one" className="flex-align gap-4 item-hover position-relative">
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-shopping-cart-simple" />
                    {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
                  </span>
                </Link>
              </div>
            </div>
          </nav>
        </div>
      </header>

      {/* ── Desktop Nav Header ── */}
      <header className="header bg-white border-bottom border-gray-100 desktop-only">
        <div className="container container-lg">
          <nav className="header-inner d-flex justify-content-between gap-8">
            <div className="flex-align menu-category-wrapper">
              <div className="mega-menu-wrapper" onMouseEnter={handleMegaMouseEnter} onMouseLeave={handleMegaMouseLeave} ref={megaMenuRef}>
                <button type="button" className="mega-menu-trigger">
                  <span style={{ fontSize: "18px", display: "flex" }}><i className="ph ph-dots-nine" /></span>
                  All Categories
                  <span style={{ fontSize: "14px", display: "flex" }}><i className="ph ph-caret-down" /></span>
                </button>
                <div className={`mega-menu-panel ${megaMenuOpen ? "open" : ""}`}>
                  <div className="mega-menu-left">
                    {categories.map((cat) => (
                      <div key={cat._id} className={`mega-menu-left-item ${megaHoveredCat?._id === cat._id ? "active" : ""}`} onMouseEnter={() => handleMegaCatHover(cat)}>
                        <span>{cat.name}</span>
                        <i className="ph ph-caret-right" style={{ fontSize: "12px", opacity: 0.5 }} />
                      </div>
                    ))}
                  </div>
                  <div className="mega-menu-right">
                    {megaHoveredCat && (
                      <>
                        <h6>{megaHoveredCat.name}</h6>
                        {subcategories[megaHoveredCat._id]?.length > 0 ? (
                          <>
                            <div className="mega-sub-grid">
                              {subcategories[megaHoveredCat._id].map((sub) => (
                                <Link key={sub._id} to={`/product-list-one?category=${megaHoveredCat._id}&subcategory=${sub._id}`} className="mega-sub-link" onClick={() => setMegaMenuOpen(false)}>
                                  <i className="ph ph-tag" style={{ marginRight: "6px", fontSize: "11px", opacity: 0.5 }} />
                                  {sub.name}
                                </Link>
                              ))}
                            </div>
                            <Link to={`/product-list-one?category=${megaHoveredCat._id}`} className="mega-view-all" onClick={() => setMegaMenuOpen(false)}>
                              View all in {megaHoveredCat.name} →
                            </Link>
                          </>
                        ) : (
                          <div style={{ fontSize: "13px", color: "#9ca3af" }}>Loading subcategories…</div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="header-menu d-lg-block d-none">
                <ul className="nav-menu flex-align">
                  <li className="nav-menu__item">
                    <NavLink to="/" className={(n) => n.isActive ? "nav-menu__link activePage" : "nav-menu__link"}>Home</NavLink>
                  </li>
                  <li className="nav-menu__item">
                    <NavLink to="/shop" className={(n) => n.isActive ? "nav-menu__link activePage" : "nav-menu__link"}>All Products</NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="header-right flex-align">
              <Link to="tel:+919993553538" className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none">
                <div className="d-flex text-32"><i className="ph ph-phone-call" /></div>
                +91 9993553538
              </Link>
            </div>
          </nav>
        </div>
      </header>

      {/* ── Category Strip ── */}
      <div className="category-strip">
        <InfiniteStripScroller categories={categories} />
      </div>

      {/* ── Mobile Bottom Navigation ── */}
      <nav className="mobile-bottom-nav">
        <button onClick={handleMenuToggle} className="mobile-bottom-nav__item">
          <i className="ph-fill ph-list mobile-bottom-nav__icon" />
          <span className="mobile-bottom-nav__label">Menu</span>
        </button>
        <NavLink to="/shop" className={({ isActive }) => isActive ? "mobile-bottom-nav__item active" : "mobile-bottom-nav__item"}>
          <i className="ph-fill ph-shopping-bag mobile-bottom-nav__icon" />
          <span className="mobile-bottom-nav__label">Products</span>
        </NavLink>
        <NavLink to="/" className={({ isActive }) => isActive ? "mobile-bottom-nav__item active" : "mobile-bottom-nav__item"}>
          <i className="ph-fill ph-house mobile-bottom-nav__icon" />
          <span className="mobile-bottom-nav__label">Home</span>
        </NavLink>
        <button onClick={handleCategoryToggle} className="mobile-bottom-nav__item">
          <i className="ph-fill ph-squares-four mobile-bottom-nav__icon" />
          <span className="mobile-bottom-nav__label">Category</span>
        </button>
        <NavLink to="/cart-one" className={({ isActive }) => isActive ? "mobile-bottom-nav__item active" : "mobile-bottom-nav__item"}>
          <i className="ph-fill ph-shopping-cart mobile-bottom-nav__icon" />
          <span className="mobile-bottom-nav__label">Cart</span>
        </NavLink>
      </nav>
    </>
  );
};

export default HeaderOne;